/* NOVYRE SIZE TOOL v9.4 FIT ENGINE — FORMA OFFICIEEL + GEKALIBREERDE BOVENRANGE + 2D CONTOUR (19-07-2026)
   Volledige vervangende code. Gebouwd op de werkende v8.8.1-UX.
   Forma gebruikt de fabrikantmatrix als basis; band 110/115 is expliciet gekalibreerd.
   Contour gebruikt een retourveilige 2D-kalibratie op onderborst én totale borstomtrek; hoge cups blijven toegestaan. */
(() => {
  // ==============================================================================
  //  NVY SIZE TOOL v8.0 — Visuele meetgids + klantgerichte copy + live-data fixes
  //
  //  v8.0 BOVENOP v7.3 (feedback Charelle, 10-06-2026):
  //   • VISUELE MEETGIDS: inline SVG-figuur (geen extern plaatje, laadt instant)
  //     met genummerde meetlijnen ① ② die 1-op-1 matchen met de invoervelden.
  //     Drie varianten: bh (onderborst/borstomtrek), bottom (taille/heup),
  //     top (borstomtrek). Focus op een veld licht de bijbehorende lijn op.
  //   • MINDER TEKST: hero-sub, tips en hints ingekort; de afbeelding legt uit.
  //   • KLANTVOORDEEL-COPY: "voorkomt retouren" (voordeel voor ons) vervangen
  //     door "zo zit je nieuwe BH in één keer écht lekker" (voordeel klant).
  //   • CTA HERTEKST: "Ik heb 'm net gemeten" → "Ik weet mijn maat al".
  //   • TITLE-CASE FIX: text-transform:none !important op knoppen/chips
  //     (Shopify-theme zette knopteksten in Title Case, zie screenshot).
  //
  //  v8.0 LIVE-DATA FIXES (geverifieerd tegen novyre.nl /products/*.js op 10-06-2026):
  //   • FORMA: live varianten heten XXL / XXL+ (niet 2XL / 2XL+). Chart
  //     aangepast zodat advies, maatkaart én "Kies"-knop exact matchen.
  //     Productnaam geüpdatet naar "Luma Forma BH 2.0" (live titel).
  //   • PUSH-UP: PUSHUP_VALID vervangen door de werkelijke live maatset
  //     (75B–110F; geen 65/70-band, geen A-cups, cups per band beperkt).
  //   • TANKTOP: 2XL → XXL (live variantnaam), in ranges én cups.
  //   • tokenMatch: size-alias vangnet XXL≡2XL en XXXL≡3XL, zodat de
  //     "Kies"-knop ook bij toekomstige naamvarianten blijft werken.
  //   • UK-MAATCONVERSIE: band 26–50 wordt herkend als UK/US-inchmaat en
  //     automatisch omgerekend (34DD → 75E), met nette vermelding in resultaat.
  //   • Sport-legging (alpha_bottom): labels toonden onterecht onderborst/
  //     borstomtrek; nu correct taille/heup (matching deed dit al goed).
  //   • Tab-knoppen kregen type="button": de tool staat ín het add-to-cart
  //     formulier (auto-inject), zonder type kon een tab-klik het formulier
  //     submitten in sommige thema's.
  //
  //  BEWUST ONGEWIJZIGD (koppelingen):
  //   • Alle data-nvyu-* attributen, element-id's en DOM-structuur-hooks
  //   • Alle tracking-events + parameters (open, tab, fast_input, fast_complete,
  //     measure_complete, quiz_answer, quiz_complete, symptom_click, apply_size,
  //     click_product) en dataLayer/gtag-koppeling
  //   • LS_KEY "nvy_size_tool_state_v7" (state-vorm gelijk; opgeslagen invoer
  //     van bezoekers blijft werken)
  //   • Variant-apply engine, /products/X.js image-fetch, auto-inject root,
  //     i18n NL/DE, shopify:section hooks, debug-mode (?nvyu_debug=1)
  //
  //  v7.3 CHANGELOG (behouden):
  //   • Contour 2D retail-safe sizing op onderborst én borstomvang, multi-fit engine,
  //     productkaarten, sticky bar, cliff-fix, UK-cupmapping, UK-bugfix.
  // ==============================================================================

  if (window.__NVYU_BLOCK_BOOTSTRAPPED__) {
    if (window.__NVYU_INIT_ALL__) window.__NVYU_INIT_ALL__();
    return;
  }
  window.__NVYU_BLOCK_BOOTSTRAPPED__ = true;

  // ------------------------------------------------------------------------------
  //  0) I18N
  // ------------------------------------------------------------------------------
  const T = window.__nvyMaatT || (window.__nvyMaatT = (function(){
    var d = {};
    try { var e = document.getElementById('nvy-maat-i18n'); if (e) d = JSON.parse(e.textContent) || {}; } catch (_) {}
    return function(k, nl){
      var v = d[k];
      if (v === undefined || v === null || v === '' || /^Translation missing/.test(String(v))) return nl;
      return v;
    };
  })());

  // ------------------------------------------------------------------------------
  //  1) STYLES — v7 baseline + v8 meetgids/numchips/linkbtn + Title-Case fix
  // ------------------------------------------------------------------------------
  const injectCustomStyles = () => {
    const styleId = "nvyu-custom-styles-v8";
    if (document.getElementById(styleId)) return;

    const css = `
      :root{
        --nvy-black:#0e0e0e;
        --nvy-text:#1b1b1b;
        --nvy-muted:#6d6d6d;
        --nvy-line:#e9e3dd;
        --nvy-soft:#f7f3ee;
        --nvy-soft-2:#f0ebe5;
        --nvy-card:#ffffff;
        --nvy-green:#27500A;
        --nvy-green-bg:#EAF3DE;
        --nvy-green-line:#97C459;
        --nvy-warn:#8a4b08;
        --nvy-warn-bg:#fff8f1;
        --nvy-warn-line:#efd9ba;
        --nvy-shadow-sm:0 8px 22px rgba(0,0,0,.05);
        --nvy-shadow-md:0 14px 36px rgba(0,0,0,.08);
        --nvy-shadow-lg:0 24px 60px rgba(0,0,0,.18);
        --nvy-radius:20px;
        --nvy-radius-sm:14px;
      }

      /* ─── TRIGGER (v5 baseline) ───────────────────────────────────────────── */
      .nvyU__trigger-wrapper{margin:20px 0 28px 0;width:100%;display:block;position:relative;z-index:10}
      .nvyU__trigger-btn{appearance:none;-webkit-appearance:none;width:100%;height:auto;display:flex;align-items:center;justify-content:space-between;gap:16px;border:1px solid #e8e0d8;border-radius:16px;padding:16px 18px;background:linear-gradient(145deg,#fff 0%,#faf8f6 100%);box-shadow:0 4px 14px rgba(90,75,61,.04),0 1px 3px rgba(90,75,61,.02);cursor:pointer;text-align:left;transition:all .3s cubic-bezier(.25,1,.5,1);position:relative;overflow:hidden;text-transform:none}
      .nvyU__trigger-btn::after{content:'';position:absolute;top:0;left:-100%;width:50%;height:100%;background:linear-gradient(to right,rgba(255,255,255,0) 0%,rgba(255,255,255,.6) 50%,rgba(255,255,255,0) 100%);transform:skewX(-25deg);transition:all .75s ease}
      .nvyU__trigger-btn:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(90,75,61,.08),0 2px 6px rgba(90,75,61,.04);border-color:#d8cec4}
      .nvyU__trigger-btn:hover::after{left:200%}
      .nvyU__trigger-btn:active{transform:translateY(0);box-shadow:0 2px 8px rgba(90,75,61,.06)}
      .nvyU__trigger-icon{flex-shrink:0;width:44px;height:44px;border-radius:12px;background:#f4efeb;display:flex;align-items:center;justify-content:center;color:#5a4b3d;border:1px solid #efe8e2;box-shadow:inset 0 2px 4px rgba(255,255,255,.5)}
      .nvyU__trigger-content{flex:1 1 0%;min-width:0;display:flex;flex-direction:column;justify-content:center;gap:6px}
      .nvyU__trigger-row{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
      .nvyU__trigger-title{font-size:15.5px;line-height:1.2;font-weight:800;color:#2c2520;letter-spacing:-.01em;white-space:normal;word-break:break-word;text-transform:none}
      .nvyU__trigger-badge{display:inline-flex;align-items:center;gap:4px;padding:4px 8px;border-radius:999px;background:#edf4ef;color:#1a6b33;border:1px solid #d4e8d8;font-size:10px;line-height:1;font-weight:800;white-space:nowrap;text-transform:uppercase;letter-spacing:.02em}
      .nvyU__trigger-sub{font-size:12.5px;line-height:1.4;color:#6d6258;font-weight:500;white-space:normal;word-break:break-word;display:block;text-transform:none}
      .nvyU__trigger-arrow{flex-shrink:0;color:#a89c91;display:flex;align-items:center;justify-content:center;min-width:20px;transition:transform .3s ease,color .3s ease}
      .nvyU__trigger-btn:hover .nvyU__trigger-arrow{transform:translateX(4px);color:#5a4b3d}

      /* ─── MODAL (v5 baseline) ─────────────────────────────────────────────── */
      .nvyU__modal{position:fixed;inset:0;z-index:2147483647;display:none}
      .nvyU__modal.is-open{display:block}
      .nvyU__overlay{position:absolute;inset:0;background:rgba(0,0,0,.48);backdrop-filter:blur(4px)}
      .nvyU__panel{position:relative;width:min(920px,calc(100vw - 24px));margin:12px auto;max-height:calc(100vh - 24px);overflow:auto;background:#fff;border-radius:22px;box-shadow:var(--nvy-shadow-lg);border:1px solid rgba(255,255,255,.4);scroll-behavior:smooth;display:flex;flex-direction:column}
      .nvyU__top{position:sticky;top:0;z-index:4;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 18px;border-bottom:1px solid rgba(0,0,0,.06);background:rgba(255,255,255,.92);backdrop-filter:blur(12px)}
      .nvyU__brand{font-size:12px;letter-spacing:.24em;font-weight:800;color:var(--nvy-text)}
      .nvyU__close{appearance:none;border:none;background:var(--nvy-soft);width:38px;height:38px;border-radius:999px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--nvy-text);font-size:22px;line-height:1}

      /* ─── HERO ─────────────────────────────────────────────────────────────── */
      .nvyU__hero{padding:22px 20px 18px 20px;background:radial-gradient(circle at top right,rgba(19,115,51,.04),transparent 28%),linear-gradient(180deg,#fff 0%,#faf7f4 100%);border-bottom:1px solid rgba(0,0,0,.05)}
      .nvyU__heroText{max-width:760px}
      .nvyU__title{margin:0 0 8px 0;color:var(--nvy-text);font-size:31px;line-height:1.02;letter-spacing:-.035em;font-weight:800}
      .nvyU__sub{margin:0;color:var(--nvy-muted);font-size:14px;line-height:1.55;font-weight:500}
      .nvyU__heroProof{margin-top:14px;display:flex;flex-wrap:wrap;gap:8px}
      .nvyU__proof{display:inline-flex;align-items:center;gap:6px;min-height:34px;padding:0 10px;border-radius:999px;background:#fff;border:1px solid #ebe4dd;font-size:12px;color:#4d4d4d;font-weight:700}
      .nvyU__heroActions{display:flex;gap:10px;flex-wrap:wrap;margin-top:16px}

      /* ─── TABS — responsive, scrollable, theme-isolated ──────────────────── */
      .nvyU__tabs{
        display:flex !important;gap:20px !important;
        overflow-x:auto !important;overflow-y:hidden !important;
        -webkit-overflow-scrolling:touch;
        padding:0 20px !important;
        border-bottom:1px solid rgba(0,0,0,.08) !important;
        background:#fff !important;
        scrollbar-width:none;
        min-height:48px !important;
      }
      .nvyU__tabs::-webkit-scrollbar{display:none}
      .nvyU__tab{
        appearance:none !important;-webkit-appearance:none !important;
        border:none !important;background:transparent !important;
        padding:14px 0 12px 0 !important;
        white-space:nowrap !important;
        color:#717171 !important;font-size:13px !important;font-weight:700 !important;
        border-bottom:2px solid transparent !important;
        cursor:pointer !important;
        flex-shrink:0 !important;
        transition:color .18s ease,border-color .18s ease !important;
        display:inline-flex !important;align-items:center !important;gap:6px !important;
        font-family:inherit !important;line-height:1.2 !important;
        text-transform:none !important;letter-spacing:normal !important;
        border-radius:0 !important;box-shadow:none !important;
        height:auto !important;min-height:auto !important;
      }
      .nvyU__tab.is-active{
        color:var(--nvy-text) !important;
        border-bottom:2px solid var(--nvy-text) !important;
        font-weight:800 !important;
      }
      .nvyU__tabBadge{
        display:inline-flex;align-items:center;
        font-size:9.5px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;
        padding:2px 6px;border-radius:999px;
        background:var(--nvy-green-bg);color:var(--nvy-green);
        border:1px solid var(--nvy-green-line);
        line-height:1.3;
      }

      /* ─── CONTENT ──────────────────────────────────────────────────────────── */
      .nvyU__content{padding:18px;background:#fbfaf9;flex:1}
      .nvyU__section{display:none}
      .nvyU__section.is-active{display:block}

      .nvyU__card{background:#fff;border:1px solid #eee9e5;border-radius:20px;padding:18px;box-shadow:0 6px 18px rgba(0,0,0,.03)}
      .nvyU__cardTitle{margin:0 0 8px 0;color:var(--nvy-text);font-size:22px;line-height:1.05;letter-spacing:-.02em;font-weight:800}

      /* ─── FIELDS ───────────────────────────────────────────────────────────── */
      .nvyU__field{margin-top:14px}
      .nvyU__label{display:block;margin-bottom:7px;font-size:13px;line-height:1.3;font-weight:800;color:var(--nvy-text)}
      .nvyU__input{width:100%;min-height:52px;border-radius:14px;border:1px solid #ddd7d2;background:#fff;padding:0 14px;font-size:15px;line-height:1;color:var(--nvy-text);outline:none;transition:border-color .18s ease,box-shadow .18s ease;text-transform:uppercase}
      .nvyU__input[type="number"]{text-transform:none}
      .nvyU__input:focus{border-color:#b8aea5;box-shadow:0 0 0 4px rgba(17,17,17,.05)}
      .nvyU__mini{margin-top:7px;font-size:12px;line-height:1.45;color:var(--nvy-muted)}
      .nvyU__grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}

      /* ─── MEETGIDS (v8) ────────────────────────────────────────────────────── */
      .nvyU__measureGrid{display:grid;grid-template-columns:230px 1fr;gap:18px;margin-top:16px;align-items:start}
      .nvyU__measureFigWrap{background:#faf6f1;border:1px solid #efe7df;border-radius:16px;padding:14px 12px 10px}
      .nvyU__measureFig{min-height:120px}
      .nvyU__measureFig svg{display:block !important;visibility:visible !important;opacity:1 !important;width:100% !important;height:auto !important;max-width:250px;margin:0 auto}
      .nvyU__measureFig svg *{visibility:visible !important}
      .nvyU__figCaption{margin-top:8px;text-align:center;font-size:11px;line-height:1.45;color:var(--nvy-muted)}
      .nvyU__measureFields{display:flex;flex-direction:column;gap:14px}
      .nvyU__measureFields .nvyU__field{margin-top:0}
      .nvyU__numChip{display:inline-flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;font-size:11px;font-weight:800;color:#fff;margin-right:8px;vertical-align:-4px}
      .nvyU__numChip--1{background:var(--nvy-green)}
      .nvyU__numChip--2{background:#0e0e0e}
      .nvyU__measureFig .nvyM{opacity:.92;transition:opacity .18s ease}
      .nvyU__measureFigWrap.hot-1 .nvyM--2{opacity:.22}
      .nvyU__measureFigWrap.hot-2 .nvyM--1{opacity:.22}
      .nvyU__linkBtn{appearance:none;background:none;border:none;padding:0;margin-top:10px;display:inline-block;font-size:12.5px;font-weight:700;color:var(--nvy-green);text-decoration:underline;text-underline-offset:3px;cursor:pointer;font-family:inherit;text-transform:none}
      .nvyU__linkBtn:hover{color:#1d3d07}

      /* ─── MICROCHECK / NUDGE ───────────────────────────────────────────────── */
      .nvyU__microCheck,.nvyU__q{margin-top:16px}
      .nvyU__ageCheck{margin-top:8px;border:1px solid #e9e2db;background:#faf7f4;border-radius:16px;padding:10px 14px}
      .nvyU__ageRow{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
      .nvyU__ageCheck .nvyU__microTitle{font-size:13px;margin-bottom:0}
      .nvyU__ageCheck .nvyU__chip{min-height:34px;font-size:12.5px;padding:0 11px}
      .nvyU__sub:empty{display:none}
      .nvyU__mini:empty{display:none}
      .nvyU__result:empty{display:none}
      .nvyU__microTitle,.nvyU__qTitle{margin-bottom:10px;font-size:14px;line-height:1.35;font-weight:800;color:var(--nvy-text)}
      .nvyU__chips{display:flex;flex-wrap:wrap;gap:8px}
      .nvyU__chip{appearance:none;border:1px solid #ddd7d2;background:#fff;color:#333;border-radius:999px;min-height:40px;padding:0 12px;font-size:13px;font-weight:700;cursor:pointer;transition:all .18s ease;text-transform:none}
      .nvyU__chip:hover{border-color:#b7ada4;background:#fcfaf8}
      .nvyU__chip.is-active{background:#111;border-color:#111;color:#fff}
      .nvyU__nudge{margin-top:12px;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;background:linear-gradient(180deg,#faf8f5 0%,#f7f2ed 100%);border:1px solid #ece2d8;border-radius:14px;padding:12px;font-size:13px;line-height:1.45;color:#4f4f4f}

      /* ─── RESULT HEADLINE ──────────────────────────────────────────────────── */
      .nvyU__result{margin-top:16px;border-radius:16px;padding:14px;border:1px solid #e9e2db;background:#faf7f4;font-size:14px;line-height:1.6;color:var(--nvy-text)}
      .nvyU__result strong{color:var(--nvy-text);font-weight:800}
      .nvyU__resRow{display:flex;align-items:center;gap:14px}
      .nvyU__sizeBig{flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;min-width:62px;min-height:46px;padding:0 14px;border-radius:13px;background:var(--nvy-green);color:#fff;font-size:21px;font-weight:800;letter-spacing:.02em;text-transform:none}
      .nvyU__resSub{color:var(--nvy-muted);font-size:12.5px;line-height:1.5}

      /* ─── PRODUCT MATCH CARDS (v6 nieuw) ───────────────────────────────────── */
      .nvyU__matchCards{display:flex;flex-direction:column;gap:10px;margin-top:14px}
      .nvyU__matchCard{
        display:flex;align-items:stretch;gap:14px;
        padding:14px;border:1px solid #e8e0d8;border-radius:14px;background:#fff;
        transition:border-color .2s ease, box-shadow .2s ease, transform .12s ease;
        animation:nvyU-cardFade .35s cubic-bezier(.25,1,.5,1) both;
      }
      @keyframes nvyU-cardFade{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
      .nvyU__matchCard:hover{border-color:#bfb6ac;box-shadow:0 4px 14px rgba(0,0,0,.04)}
      .nvyU__matchCard.is-best{border:1.5px solid var(--nvy-green-line);background:var(--nvy-green-bg);box-shadow:0 4px 18px rgba(39,80,10,.06)}
      .nvyU__matchCard.is-oos{opacity:.7;border-style:dashed}

      .nvyU__matchImg{
        flex-shrink:0;width:90px;height:90px;border-radius:11px;
        background:#f4efeb;
        background-image:linear-gradient(135deg,#f4efeb 0%,#ede7e0 100%);
        display:flex;align-items:center;justify-content:center;overflow:hidden;
        position:relative;
      }
      .nvyU__matchImg img{width:100%;height:100%;object-fit:cover;display:block}
      .nvyU__matchImg.is-loading::before{
        content:"";position:absolute;inset:0;
        background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,.5) 50%,transparent 100%);
        animation:nvyU-shimmer 1.4s ease-in-out infinite;
      }
      @keyframes nvyU-shimmer{0%{transform:translateX(-100%)}100%{transform:translateX(100%)}}

      .nvyU__matchInfo{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;justify-content:center;gap:5px}
      .nvyU__matchRow{display:flex;align-items:center;gap:6px;flex-wrap:wrap}
      .nvyU__matchBadge{
        display:inline-flex;align-items:center;gap:3px;
        padding:3px 8px;border-radius:999px;
        font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;line-height:1.4;
        background:var(--nvy-green);color:#fff;border:1px solid var(--nvy-green);
      }
      .nvyU__matchBadge--ok{background:#faf7f4;color:#5a4b3d;border-color:#e9e3dd}
      .nvyU__matchBadge--warn{background:#fff8f1;color:#8a4b08;border-color:#efd9ba}
      .nvyU__matchBadge--oos{background:#f1eeed;color:#888;border-color:#d9d4cf}
      .nvyU__matchName{font-size:14.5px;font-weight:800;color:#1b1b1b;letter-spacing:-.005em;line-height:1.25}
      .nvyU__matchSize{font-size:12px;color:#5a4b3d;font-weight:600}
      .nvyU__matchSize strong{color:#111;font-weight:800}
      .nvyU__matchHint{font-size:11.5px;color:#6d6258;line-height:1.45;margin-top:1px}

      .nvyU__matchCta{flex-shrink:0;display:flex;align-items:center;justify-content:center;min-width:120px}
      .nvyU__matchCta .nvyU__btn,
      .nvyU__matchCta a.nvyU__btn{min-height:42px;padding:0 14px;font-size:13px;border-radius:11px;width:100%}

      .nvyU__matchEmpty{
        padding:14px;border:1px dashed #ddd7d2;border-radius:14px;
        text-align:center;color:var(--nvy-muted);font-size:13px;line-height:1.5;
      }

      /* ─── BUTTONS (v8: + text-transform fix tegen theme Title-Case) ───────── */
      .nvyU__btn,.nvyU__bigBtn{
        appearance:none !important;-webkit-appearance:none !important;
        border:none;text-decoration:none !important;
        border-radius:14px !important;min-height:48px !important;padding:0 18px !important;
        display:inline-flex !important;align-items:center !important;justify-content:center !important;gap:8px;
        font-size:14px !important;font-weight:800 !important;line-height:1 !important;
        cursor:pointer;letter-spacing:.005em !important;font-family:inherit !important;
        text-transform:none !important;
        transition:transform .18s ease,box-shadow .18s ease,opacity .18s ease,border-color .18s ease,background .18s ease !important;
      }
      .nvyU__btn:hover,.nvyU__bigBtn:hover{transform:translateY(-1px)}
      .nvyU__btn--primary,.nvyU__bigBtn--primary{
        background:#111 !important;color:#fff !important;border:1px solid #111 !important;
        box-shadow:0 8px 22px rgba(17,17,17,.16) !important;
      }
      .nvyU__btn--primary:hover,.nvyU__bigBtn--primary:hover{background:#000 !important;border-color:#000 !important}
      .nvyU__btn--ghost,.nvyU__bigBtn--ghost{
        background:#fff !important;color:#111 !important;border:1px solid #ddd7d2 !important;
        box-shadow:none !important;
      }
      .nvyU__btn--ghost:hover,.nvyU__bigBtn--ghost:hover{border-color:#bfb6ac !important;background:#faf7f4 !important}
      .nvyU__btn--accent{
        background:var(--nvy-green) !important;color:#fff !important;border:1px solid var(--nvy-green) !important;
        box-shadow:0 8px 18px rgba(39,80,10,.18) !important;
      }
      .nvyU__btn--accent:hover{background:#1d3d07 !important;border-color:#1d3d07 !important}
      .nvyU__bigBtn{min-height:54px !important;font-size:15px !important;border-radius:14px !important;padding:0 22px !important}

      /* ─── HERO NUDGE (v7.2) ────────────────────────────────────────────── */
      .nvyU__heroNudge{
        margin-top:12px;font-size:12.5px;color:var(--nvy-muted);line-height:1.5;
        display:flex;align-items:flex-start;gap:6px;
      }
      .nvyU__heroNudge::before{
        content:"";flex-shrink:0;width:6px;height:6px;border-radius:50%;
        background:var(--nvy-green);margin-top:7px;
      }

      /* ─── TABLE ────────────────────────────────────────────────────────────── */
      .nvyU__tableWrap{margin-top:12px;overflow:auto;background:#fff;border:1px solid #eee7e1;border-radius:16px}
      .nvyU__table{width:100%;min-width:620px;border-collapse:collapse}
      .nvyU__table th,.nvyU__table td{padding:12px 14px;border-bottom:1px solid #f0ece8;text-align:left;font-size:13px;line-height:1.45;color:#2d2d2d}
      .nvyU__table th{background:#faf7f4;color:#666;font-size:12px;font-weight:800}
      .nvyU__hintline{margin-top:10px;font-size:12px;line-height:1.5;color:var(--nvy-muted)}

      /* ─── FIT TAG (in quiz advice) ─────────────────────────────────────────── */
      .nvyU__fitTag{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;border-radius:999px;font-size:11px;line-height:1;font-weight:800;margin-bottom:8px}
      .nvyU__fitTag--good{background:#edf8ef;color:#137333;border:1px solid #cfe7d4}
      .nvyU__fitTag--warn{background:#fff8f1;color:#8a4b08;border:1px solid #f0d8b8}

      /* ─── STICKY BOTTOM BAR ────────────────────────────────────────────────── */
      .nvyU__bottomBar{
        position:sticky;bottom:0;
        background:rgba(255,255,255,.97);
        backdrop-filter:blur(10px);
        border-top:1px solid rgba(0,0,0,.08);
        padding:12px 14px;
        display:flex;align-items:center;gap:10px;
        z-index:5;
      }
      .nvyU__stickyMeta{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;overflow:hidden}
      .nvyU__stickyTitle{font-size:12.5px;font-weight:800;color:var(--nvy-text);line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .nvyU__stickyTitle strong{color:var(--nvy-green)}
      .nvyU__stickySub{font-size:11px;color:var(--nvy-muted);line-height:1.35;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .nvyU__stickyCta{flex-shrink:0;display:flex;gap:6px}
      .nvyU__stickyCta .nvyU__btn,
      .nvyU__stickyCta a.nvyU__btn{min-height:42px;padding:0 14px;font-size:13px;border-radius:11px}

      /* ─── MOBILE ───────────────────────────────────────────────────────────── */
      @media (max-width: 768px){
        .nvyU__panel{width:calc(100vw - 10px);margin:5px auto;max-height:calc(100dvh - 10px);height:calc(100dvh - 10px);border-radius:18px}
        .nvyU__top{padding:14px}
        .nvyU__input{font-size:16px;min-height:54px}
        .nvyU__btn,.nvyU__bigBtn,.nvyU__chip,.nvyU__tab{touch-action:manipulation;-webkit-tap-highlight-color:rgba(0,0,0,.08)}
        .nvyU__btn:active,.nvyU__bigBtn:active,.nvyU__chip:active,.nvyU__tab:active{transform:translateY(1px) scale(.99)!important}
        .nvyU__hero{padding:18px 14px 14px 14px}
        .nvyU__title{font-size:24px}
        .nvyU__sub{font-size:13px}
        .nvyU__tabs{padding:0 14px;gap:16px}
        .nvyU__content{padding:14px}
        .nvyU__card{padding:14px;border-radius:16px}
        .nvyU__grid{grid-template-columns:1fr}
        .nvyU__heroActions{flex-direction:column}
        .nvyU__bigBtn{width:100%}
        .nvyU__nudge{align-items:flex-start}

        /* Meetgids op mobile: figuur boven, velden eronder */
        .nvyU__measureGrid{grid-template-columns:1fr;gap:12px}
        .nvyU__measureFigWrap{max-width:240px;margin:0 auto;width:100%}

        /* Match cards op mobile: image klein links, info middel, knop onder full-width */
        .nvyU__matchCard{flex-wrap:wrap;gap:10px;padding:12px}
        .nvyU__matchImg{width:56px;height:56px;border-radius:10px;align-self:flex-start}
        .nvyU__matchInfo{min-width:0;flex:1 1 60%}
        .nvyU__matchCta{flex:1 1 100%;min-width:0;justify-content:stretch}
        .nvyU__matchCta .nvyU__btn,.nvyU__matchCta a.nvyU__btn{min-height:44px}
        .nvyU__matchName{font-size:14px;line-height:1.3}
        .nvyU__matchHint{font-size:11.5px;line-height:1.5}

        /* Sticky bar */
        .nvyU__bottomBar{padding:10px 12px}
        .nvyU__stickyTitle{font-size:12px}
        .nvyU__stickySub{font-size:10.5px}

        /* Trigger */
        .nvyU__trigger-btn{padding:12px 14px;gap:12px;border-radius:14px}
        .nvyU__trigger-icon{width:38px;height:38px;border-radius:10px}
        .nvyU__trigger-icon svg{width:18px;height:18px}
        .nvyU__trigger-title{font-size:14.5px}
        .nvyU__trigger-sub{font-size:11.5px;line-height:1.35}
        .nvyU__trigger-badge{font-size:9.5px;padding:3px 6px}
      }
    `;

    const styleEl = document.createElement("style");
    styleEl.id = styleId;
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  };

  // ------------------------------------------------------------------------------
  //  1B) AUTO-INJECT ROOT
  // ------------------------------------------------------------------------------
  // v7.1: robuuste handle-detectie — probeert window.meta, data-product-handle,
  // en als laatste fallback de URL pathname /products/<handle>
  const detectHandleFromPage = () => {
    try {
      if (window.meta?.product?.handle) return window.meta.product.handle;
      const attrEl = document.querySelector("[data-product-handle]");
      if (attrEl) { const h = attrEl.getAttribute("data-product-handle"); if (h) return h; }
      // Shopify product JSON in DOM (sommige thema's gebruiken script tags)
      const jsonEl = document.querySelector('script[type="application/json"][data-product-json], script[type="application/json"][id*="product-json"]');
      if (jsonEl) { try { const j = JSON.parse(jsonEl.textContent); if (j?.handle) return j.handle; if (j?.product?.handle) return j.product.handle; } catch(e) {} }
      // URL fallback: /products/X
      const m = (window.location.pathname || "").match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    } catch(e) {}
    return "";
  };

  const ensureRootExists = () => {
    if (document.querySelector("[data-nvyu-root]")) return;
    const main = document.querySelector("main") || document.body;
    const form = main.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const insertPoint = form.querySelector(".product-form__buttons") || form.querySelector(".buy-buttons") || form.querySelector("[data-buy-buttons]") || form;
    const root = document.createElement("div");
    root.setAttribute("data-nvyu-root", "auto");
    root.setAttribute("data-nvy-mode", "bra");
    const handle = detectHandleFromPage();
    if (handle) root.setAttribute("data-current-handle", handle);
    insertPoint.insertBefore(root, insertPoint.firstChild);
  };

  // ------------------------------------------------------------------------------
  //  2) UTILS (v5 baseline + UK cup mapping + v8 UK-bandconversie)
  // ------------------------------------------------------------------------------
  const CUP_ORDER = ["AA","A","B","C","D","E","F","G","H","I","J","K"];
  const cupIndex = (cup) => CUP_ORDER.indexOf(String(cup || "").toUpperCase());
  const cupAtLeast = (cup, minCup) => cupIndex(cup) >= cupIndex(minCup);
  const cupGreaterThanD = (cup) => cupAtLeast(cup, "E");
  const cupVeryHigh = (cup) => cupAtLeast(cup, "I");

  const normalizeBra = (str) => (str || "").toUpperCase().replace(/\s+/g, "").replace(/[^0-9A-Z]/g, "");

  // v8.4: sister sizes (band -5 met cup +1, band +5 met cup -1) hebben bijna
  // hetzelfde cupvolume. Gebruikt om een verouderde maat-overtuiging zacht te
  // openen: geen oordeel, wel een kennis-cadeautje.
  const sisterSizes = (band, cup) => {
    const ci = cupIndex(cup);
    const out = [];
    if (band - 5 >= 60 && ci + 1 < CUP_ORDER.length) out.push(`${band - 5}${CUP_ORDER[ci + 1]}`);
    if (band + 5 <= 120 && ci - 1 >= 0) out.push(`${band + 5}${CUP_ORDER[ci - 1]}`);
    return out;
  };

  // v5.1 PATCH 1: UK cup mapping
  const UK_CUP_MAP = { "DD":"E","DDD":"F","EE":"F","FF":"G","GG":"H","HH":"I","JJ":"J" };
  const normalizeCup = (cup) => { const u = String(cup || "").toUpperCase().trim(); return UK_CUP_MAP[u] || u; };

  // v8: UK/US-bandmaten zijn inches (26–50); EU-banden beginnen pas bij 60.
  // 28→60, 30→65, 32→70, 34→75, 36→80, 38→85, 40→90, 42→95, 44→100, 46→105, 48→110.
  const parseBra = (braString) => {
    const clean = normalizeBra(braString);
    const m = clean.match(/^(\d{2,3})([A-Z]{1,3})$/);  // v5.1 PATCH 2
    if (!m) return null;
    const cup = normalizeCup(m[2]);
    if (CUP_ORDER.indexOf(cup) === -1) return null;
    let band = Number(m[1]);
    let uk = null;
    if (band >= 26 && band <= 50) {
      uk = `${m[1]}${m[2]}`;
      band = Math.max(60, Math.round((band * 2.5 - 10) / 5) * 5);
    }
    return { band, cup, uk };
  };

  const fmtNum = (num) => Number.isInteger(num) ? String(num) : String(num).replace(".", ",");
  const rangeLabel = (min, max) => `${fmtNum(min)} tot ${fmtNum(max)} cm`;
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));
  const uniq = (arr) => Array.from(new Set(arr || []));

  const estimateBustCmFromBra = (braString) => {
    const p = parseBra(braString);
    if (!p) return null;
    const CUP_DIFF_MID = { "AA":11,"A":13,"B":15,"C":17,"D":19,"E":21,"F":23,"G":25,"H":27,"I":29,"J":31,"K":33 };
    const diff = CUP_DIFF_MID[String(p.cup).toUpperCase()] ?? 19;
    return p.band + diff;
  };

  const mapBustCmToContourSize = (bustCm, ranges) => {
    if (!bustCm || !Array.isArray(ranges) || !ranges.length) return null;
    const r = ranges.slice().sort((a,b) => a.min - b.min);
    for (let i = 0; i < r.length; i++) {
      const cur = r[i];
      if (bustCm < cur.min) continue;
      if (bustCm > cur.max) continue;
      if (bustCm === cur.max && r[i + 1]) return r[i + 1].s;
      return cur.s;
    }
    for (let i = 0; i < r.length - 1; i++) {
      const cur = r[i], nxt = r[i + 1];
      if (bustCm > cur.max && bustCm < nxt.min) return nxt.s;
    }
    if (bustCm < r[0].min) return r[0].s;
    return r[r.length - 1].s;
  };

  // v9.4 FIT ENGINE — Forma heeft drie duidelijk gescheiden niveaus:
  // 1) fabrikant_exact: band 70–105, rechtstreeks uit de bruine fabrikantkaart;
  // 2) calibrated_110: één bandstap boven de kaart, met extender;
  // 3) calibrated_115: gecontroleerde bovengrens D–H, met extender.
  // Er is nooit een fallback naar een andere band, lagere cup of "dichtstbijzijnde" cel.
  // Shopify gebruikt XXL/XXL+ waar de fabrikantkaart 2XL/2XL+ toont.
  const FORMA_OFFICIAL_BAND_TO_COL = { 70:32,75:34,80:36,85:38,90:40,95:42,100:44,105:46 };
  const FORMA_OFFICIAL_CHART = {
    A:{32:"XS",34:"XS",36:null,38:null,40:null,42:null,44:null,46:null},
    B:{32:"XS",34:"S",36:"S",38:"M",40:"L",42:"L",44:"XL",46:null},
    C:{32:"XS",34:"S",36:"M",38:"L",40:"L",42:"XL",44:"XXL",46:"XXL"},
    D:{32:"S",34:"S",36:"M",38:"L",40:"L+",42:"XL",44:"XXL",46:"3XL"},
    E:{32:"S+",34:"M",36:"M+",38:"XL",40:"XL",42:"XL",44:"XXL",46:"3XL"},
    F:{32:null,34:"M+",36:"L+",38:"XL",40:"XL+",42:"XXL",44:"XXL+",46:"3XL"},
    G:{32:null,34:null,36:"L+",38:"XL+",40:"XXL",42:"XXL+",44:"XXL+",46:"3XL+"},
    H:{32:null,34:null,36:null,38:"XL+",40:"XXL+",42:"XXL+",44:"3XL+",46:"3XL+"}
  };

  // De fabrikantkaart eindigt bij EU-band 105. Novyre levert een extender.
  // De bovenrange is daarom bewust apart vastgelegd en nooit als fabrikantcel gelabeld.
  const FORMA_CALIBRATED_CHART = {
    110:{ C:"XXL", D:"3XL", E:"3XL", F:"3XL", G:"3XL+", H:"3XL+" },
    115:{ D:"3XL", E:"3XL", F:"3XL", G:"3XL+", H:"3XL+" }
  };
  const FORMA_DISPLAY_BANDS = [70,75,80,85,90,95,100,105,110,115];

  const getFormaCellAdvice = (band, cup) => {
    const b = Number(band);
    const c = String(cup || "").toUpperCase();
    const col = FORMA_OFFICIAL_BAND_TO_COL[b];
    if (col) {
      const size = (FORMA_OFFICIAL_CHART[c] && FORMA_OFFICIAL_CHART[c][col]) || null;
      return size ? { size, confidence:"manufacturer_exact", requiresExtender:false } : null;
    }
    const size = (FORMA_CALIBRATED_CHART[b] && FORMA_CALIBRATED_CHART[b][c]) || null;
    if (!size) return null;
    return {
      size,
      confidence: b === 110 ? "calibrated_110" : "calibrated_115",
      requiresExtender:true
    };
  };

  const getFormaSizeFromChart = (braString) => {
    const parts = parseBra(braString);
    if (!parts) return null;
    const advice = getFormaCellAdvice(parts.band, parts.cup);
    return advice ? advice.size : null;
  };

  // Cupdruk wordt berekend met het werkelijk gemeten verschil:
  // borstomtrek minus gemeten onderborst. Bovengrenzen zijn inclusief.
  const MEASURED_CUP_RULES = [
    {max:12,cup:"AA"},{max:14,cup:"A"},{max:16,cup:"B"},
    {max:18,cup:"C"},{max:20,cup:"D"},{max:22,cup:"E"},
    {max:24,cup:"F"},{max:26,cup:"G"},{max:28,cup:"H"},
    {max:30,cup:"I"},{max:32,cup:"J"},{max:34,cup:"K"}
  ];

  const cupFromMeasuredDifference = (diff) => {
    const d = Number(diff);
    if (!Number.isFinite(d)) return null;
    const hit = MEASURED_CUP_RULES.find(r => d <= r.max);
    return hit ? { cup:hit.cup, overflow:false } : { cup:"K", overflow:true };
  };

  const measuredBandFromUnder = (under) => Math.round(Number(under) / 5) * 5;

  const getMeasuredBraProfile = (under, bust) => {
    const u = Number(under), b = Number(bust);
    if (!Number.isFinite(u) || !Number.isFinite(b) || u < 55 || u > 140 || b <= u) return null;
    const band = measuredBandFromUnder(u);
    const diff = Math.round((b - u) * 10) / 10;
    const cupInfo = cupFromMeasuredDifference(diff);
    if (!cupInfo) return null;
    const cup = cupInfo.cup;
    return {
      under:u,
      bust:b,
      band,
      diff,
      cup,
      bra:`${band}${cup}`,
      overflow:cupInfo.overflow,
      upperBandEdge:u >= band + 1.5,
      lowerBandEdge:u <= band - 1.5,
      bandEdge:Math.abs(u - band) >= 1.5
    };
  };

  const getFormaMeasuredAdvice = (under, bust) => {
    const profile = getMeasuredBraProfile(under, bust);
    if (!profile) return {
      supported:false,size:null,profile:null,confidence:"invalid",requiresExtender:false,
      reason:T("controleer_je_metingen", "Controleer je metingen.")
    };

    const cell = profile.overflow ? null : getFormaCellAdvice(profile.band, profile.cup);
    if (cell) {
      const requiresExtender = cell.requiresExtender || profile.upperBandEdge;
      let reason;
      if (cell.confidence === "manufacturer_exact") {
        reason = requiresExtender
          ? T("exacte_fabrikantmatch_je_zit_aan_de", "Exacte fabrikantmatch; je zit aan de ruime kant van deze bandgroep. Gebruik de extender voor comfort.")
          : T("exacte_combinatie_uit_de_forma_fabrikantkaart", "Exacte combinatie uit de Forma-fabrikantkaart.");
      } else if (cell.confidence === "calibrated_110") {
        reason = T("gekalibreerde_forma_bovenrange_voor_band_110", "Gekalibreerde Forma-bovenrange voor band 110. Gebruik de meegeleverde extender.");
      } else {
        reason = T("gekalibreerde_forma_bovengrens_voor_band_115", "Gekalibreerde Forma-bovengrens voor band 115, alleen binnen cupdruk D–H. Gebruik de meegeleverde extender.");
      }
      return { supported:true,size:cell.size,profile,confidence:cell.confidence,requiresExtender,reason };
    }

    let reason;
    if (profile.band < 70) {
      reason = T("je_onderband_valt_onder_de_betrouwbaar", "Je onderband valt onder de betrouwbaar ondersteunde Forma-range.");
    } else if (profile.band > 115) {
      reason = T("je_onderband_valt_boven_de_gekalibreerde", "Je onderband valt boven de gekalibreerde Forma-bovengrens.");
    } else if (profile.cup === "AA") {
      reason = T("de_gevormde_forma_cup_is_bij", "De gevormde Forma-cup is bij deze borst-/bandverhouding waarschijnlijk te ruim.");
    } else if (profile.overflow || cupAtLeast(profile.cup,"I")) {
      reason = T("de_forma_biedt_bij_deze_verhouding", "De Forma biedt bij deze verhouding niet betrouwbaar genoeg cupdiepte.");
    } else if (profile.band === 110 && ["A","B"].includes(profile.cup)) {
      reason = T("bij_band_110_is_forma_pas", "Bij band 110 is Forma pas vanaf cupdruk C verantwoord gekalibreerd.");
    } else if (profile.band === 115 && ["A","B","C"].includes(profile.cup)) {
      reason = T("bij_band_115_is_forma_alleen", "Bij band 115 is Forma alleen voor cupdruk D–H verantwoord gekalibreerd.");
    } else {
      reason = T("deze_band_en_cupcombinatie_staat_niet", "Deze band- en cupcombinatie staat niet in de betrouwbare Forma-matrix.");
    }
    return { supported:false,size:null,profile,confidence:"unsupported",requiresExtender:false,reason };
  };

  const getFormaMeasuredSizeFromCm = (under, bust) => getFormaMeasuredAdvice(under, bust).size;
  const getFormaMeasuredHint = (under, bust) => {
    const a = getFormaMeasuredAdvice(under, bust);
    if (!a.profile || !a.supported) return a.reason;
    const suffix = a.requiresExtender ? T("extender_aanbevolen", " · extender aanbevolen.") : "";
    if (a.confidence === "manufacturer_exact") return T("a_profile_bra_exacte_fabrikantmatch_suffix", "%bra% · exacte fabrikantmatch%suffix%").replace("%bra%", a.profile.bra).replace("%suffix%", suffix);
    if (a.confidence === "calibrated_110") return T("a_profile_bra_gekalibreerde_band_110", "%bra% · gekalibreerde band 110%suffix%").replace("%bra%", a.profile.bra).replace("%suffix%", suffix);
    return T("a_profile_bra_gekalibreerde_band_115", "%bra% · gekalibreerde band 115%suffix%").replace("%bra%", a.profile.bra).replace("%suffix%", suffix);
  };

  const formaUnderRangeLabel = (band) => `${band - 2}–${band + 2} cm`;
  const compactFormaBandAdvice = (band) => {
    const cups = ["A","B","C","D","E","F","G","H"];
    const groups = [];
    let start = null, prev = null, key = null, display = null;
    const flush = () => {
      if (!display || !start) return;
      groups.push(`${start === prev ? start : `${start}–${prev}`} → ${display}`);
    };
    cups.forEach(cup => {
      const advice = getFormaCellAdvice(band,cup);
      const nextKey = advice ? `${advice.size}|${advice.requiresExtender?1:0}` : null;
      const nextDisplay = advice ? `${advice.size}${advice.requiresExtender ? "*" : ""}` : null;
      if (nextKey === key && nextKey) { prev = cup; return; }
      flush();
      start = nextKey ? cup : null;
      prev = nextKey ? cup : null;
      key = nextKey;
      display = nextDisplay;
    });
    flush();
    return groups.join(" · ") || "—";
  };

  // ------------------------------------------------------------------------------
  //  2B) MEETGIDS — inline SVG-figuren (v8)
  //  Drie varianten: 'bra' (onderborst ① + borstomtrek ②),
  //  'bottom' (taille ① + heup ②), 'top' (borstomtrek ①).
  //  Genummerde badges matchen de nvyU__numChip kleuren bij de velden.
  // ------------------------------------------------------------------------------
  const NVY_FIG = { m1:"#27500A", m2:"#0e0e0e", line:"#cbbfb3", fill:"#f3ece4", soft:"#dcd0c3", bg:"#faf6f1", bra:"#d8c8b4", braLine:"#ab987f" };

  // v8.2: hertekend naar referentie-stijl maatgids — figuur ZONDER BH,
  // borsten anatomisch zichtbaar (onderborstplooi + decolleté), en de
  // meetlinten als banden die zichtbaar OM het lichaam wikkelen: ze lopen
  // door tot achter de armen. Het nummer staat ÓP de band (zoals de
  // gekleurde chips bij de invoervelden). ② over het volste punt van de
  // borst, ① strak onder de borst.
  const measureSVG = (kind) => {
    const C = NVY_FIG;
    const num = (cx, cy, n) => `<text x="${cx}" y="${cy}" text-anchor="middle" dominant-baseline="central" font-size="14" font-weight="800" fill="#ffffff" font-family="inherit">${n}</text>`;
    const ticks = (pts) => pts.map(tk => `<line x1="${tk[0]}" y1="${tk[1] - 3}" x2="${tk[0]}" y2="${tk[1] + 3}" stroke="#ffffff" stroke-width="1.3" stroke-linecap="round" opacity=".75" transform="rotate(${tk[2]} ${tk[0]} ${tk[1]})"/>`).join("");
    const defs = `<defs><linearGradient id="nvy8fade" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${C.bg}" stop-opacity="0"/><stop offset="1" stop-color="${C.bg}" stop-opacity="1"/></linearGradient><linearGradient id="nvy8fadeTop" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${C.bg}" stop-opacity="1"/><stop offset="1" stop-color="${C.bg}" stop-opacity="0"/></linearGradient></defs>`;

    // v8.2.2: LIVE op novyre.nl gediagnosticeerd — het thema (of een app)
    // verbergt svg's met display:none / visibility:hidden / opacity:0 tot
    // een eigen "reveal"-script ze toont; onze dynamisch geinjecteerde
    // figuur kreeg die reveal nooit. Inline styles met !important winnen
    // van elke stylesheet-regel en zijn live geverifieerd als werkend.
    const svgOpen = (w, h) => `<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" style="display:block !important;visibility:visible !important;opacity:1 !important;width:100% !important;height:auto !important;max-width:${w}px;margin:0 auto" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" focusable="false">`;

    if (kind === "bottom") {
      return `${svgOpen(220, 218)}${defs}
        <path d="M78,28 C76,44 71,57 64,72 C57,87 52,103 55,118 C58,134 68,146 76,158 C82,170 86,184 86,206 L134,206 C134,184 138,170 144,158 C152,146 162,134 165,118 C168,103 163,87 156,72 C149,57 144,44 142,28 Z" fill="${C.fill}" stroke="${C.line}" stroke-width="2" stroke-linejoin="round"/>
        <path d="M60,128 C85,140 135,140 160,128 C157,146 134,168 113,178 L107,178 C86,168 63,146 60,128 Z" fill="${C.bra}" stroke="${C.braLine}" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M63,135 C86,146 134,146 157,135" fill="none" stroke="${C.braLine}" stroke-width="1.2"/>
        <path d="M110,180 L110,206" fill="none" stroke="${C.soft}" stroke-width="1.6"/>
        <g class="nvyM nvyM--1"><path d="M62,64 C90,76 130,76 158,64 L158,75 C130,87 90,87 62,75 Z" fill="${C.m1}"/>${ticks([[80,75,9],[95,78,4],[125,78,-4],[140,75,-9]])}${num(110,78.5,"1")}</g>
        <g class="nvyM nvyM--2"><path d="M50,117 C84,131 136,131 170,117 L170,128 C136,142 84,142 50,128 Z" fill="${C.m2}"/>${ticks([[72,130,10],[91,133,5],[129,133,-5],[148,130,-10]])}${num(110,133,"2")}</g>
        <rect x="52" y="22" width="116" height="22" fill="url(#nvy8fadeTop)"/>
        <rect x="46" y="184" width="128" height="26" fill="url(#nvy8fade)"/>
      </svg>`;
    }

    // Gedeeld bovenlijf voor 'bra' en 'top': hals (loopt uit beeld),
    // sleutelbeenderen, torso met borstcontour, onderborstplooien en
    // decolleté. Armen worden NA de banden getekend zodat de banden er
    // zichtbaar achter verdwijnen (wikkel-effect).
    // v8.3: vrouwelijker silhouet na feedback: zandloper-taille met
    // zichtbare heupwelving, slankere armen die onder de elleboog naar
    // buiten lopen (taille komt vrij), vollere borstplooien.
    const upperBody = `
        <path d="M106,4 C106,18 105,32 100,46 M134,4 C134,18 135,32 140,46" fill="none" stroke="${C.line}" stroke-width="2" stroke-linecap="round"/>
        <path d="M100,46 C90,51 78,53 66,59 C58,63 54,71 56,81 C51,91 48,103 50,115 C51,127 56,133 59,139 C63,151 63,161 60,170 C56,182 50,194 47,210 L47,219 L193,219 L193,210 C190,194 184,182 180,170 C177,161 177,151 181,139 C184,133 189,127 190,115 C192,103 189,91 184,81 C186,71 182,63 174,59 C162,53 150,51 140,46 C132,49 108,49 100,46 Z" fill="${C.fill}" stroke="${C.line}" stroke-width="2" stroke-linejoin="round"/>
        <path d="M80,60 C94,56 106,58 114,63 M160,60 C146,56 134,58 126,63" fill="none" stroke="${C.soft}" stroke-width="1.6" stroke-linecap="round"/>
        <path d="M56,98 C52,107 51,116 53,124 M184,98 C188,107 189,116 187,124" fill="none" stroke="${C.soft}" stroke-width="1.6" stroke-linecap="round"/>
        <path d="M58,130 C64,147 80,154 97,149 C110,145 116,131 113,116 M182,130 C176,147 160,154 143,149 C130,145 124,131 127,116" fill="none" stroke="${C.soft}" stroke-width="1.8" stroke-linecap="round"/>`;
    const arms = `
        <path d="M68,58 C57,62 49,72 46,87 C42,102 42,117 44,131 C44,143 40,158 33,174 C29,184 26,192 24,199 L36,202 C40,192 44,182 48,170 C52,158 54,146 55,134 C56,116 58,98 63,83 C65,74 67,64 68,58 Z" fill="${C.fill}" stroke="${C.line}" stroke-width="2" stroke-linejoin="round"/>
        <path d="M172,58 C183,62 191,72 194,87 C198,102 198,117 196,131 C196,143 200,158 207,174 C211,184 214,192 216,199 L204,202 C200,192 196,182 192,170 C188,158 186,146 185,134 C184,116 182,98 177,83 C175,74 173,64 172,58 Z" fill="${C.fill}" stroke="${C.line}" stroke-width="2" stroke-linejoin="round"/>`;
    const fades = `
        <rect x="92" y="0" width="56" height="18" fill="url(#nvy8fadeTop)"/>
        <rect x="16" y="196" width="208" height="30" fill="url(#nvy8fade)"/>`;

    const bandBust = (color) => `<path d="M44,107 C85,123 155,123 196,107 L196,118 C155,134 85,134 44,118 Z" fill="${color}"/>${ticks([[72,120,10],[95,123,5],[145,123,-5],[168,120,-10]])}`;
    const bandUnder = `<path d="M46,146 C88,161 152,161 194,146 L194,157 C152,172 88,172 46,157 Z" fill="${C.m1}"/>${ticks([[74,159,9],[96,162,4],[144,162,-4],[166,159,-9]])}`;

    if (kind === "top") {
      return `${svgOpen(240, 226)}${defs}${upperBody}
        <g class="nvyM nvyM--1">${bandBust(C.m1)}</g>
        ${arms}
        <g class="nvyM nvyM--1">${num(120,124.5,"1")}</g>
        ${fades}
      </svg>`;
    }

    // 'bra' (default)
    return `${svgOpen(240, 226)}${defs}${upperBody}
        <g class="nvyM nvyM--2">${bandBust(C.m2)}</g>
        <g class="nvyM nvyM--1">${bandUnder}</g>
        ${arms}
        <g class="nvyM nvyM--2">${num(120,124.5,"2")}</g>
        <g class="nvyM nvyM--1">${num(120,162.75,"1")}</g>
        ${fades}
      </svg>`;
  };

  // ------------------------------------------------------------------------------
  //  2C) PRODUCT IMAGE CACHE — fetch via /products/X.js
  // ------------------------------------------------------------------------------
  const PRODUCT_IMG_CACHE = {};
  const fetchProductImage = async (handle) => {
    if (!handle) return null;
    if (handle in PRODUCT_IMG_CACHE) return PRODUCT_IMG_CACHE[handle];
    try {
      const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      const data = await r.json();
      let url = data.featured_image || (data.images && data.images[0]) || null;
      if (url && url.startsWith('//')) url = 'https:' + url;
      PRODUCT_IMG_CACHE[handle] = url;
      return url;
    } catch(e) {
      PRODUCT_IMG_CACHE[handle] = null;
      return null;
    }
  };

  // ------------------------------------------------------------------------------
  //  3) PUSHUP + PRODUCTS
  // ------------------------------------------------------------------------------
  // v8: exact de live variantenset van vitasculpt-push-up-bh-1 (novyre.nl,
  // geverifieerd 10-06-2026). Voorheen stonden hier ook 65/70-banden en
  // A-cups die live niet bestaan → advies op niet-bestaande maten.
  const PUSHUP_VALID = new Set([
    "75B","75C","75D","75E","75F",
    "80B","80C","80D","80E","80F",
    "85B","85C","85D","85E","85F","85G",
    "90C","90D","90E","90F","90G",
    "95C","95D","95E","95F","95G","95H",
    "100C","100D","100E","100F","100G",
    "105C","105D","105E","105F",
    "110C","110D","110E","110F"
  ]);

  const PRODUCTS = {
    forma: { name:T("loose_003", "Luma Forma BH 2.0"), handle:"luma-forma-bh", url:"https://novyre.nl/products/luma-forma-bh", type:"alpha_bra" },
    contour: {
      name:T("loose_005", "Luma Contour BH"), handle:"luma-contour-bh", url:"https://novyre.nl/products/luma-contour-bh", type:"alpha_bra",
      // Alleen voor maatvolgorde/variantselectie; pasvorm komt uit de 2D-engine.
      ranges:[
        {s:"S",min:0,max:97},
        {s:"M",min:98,max:105},
        {s:"L",min:106,max:112},
        {s:"XL",min:113,max:119},
        {s:"XXL",min:120,max:140}
      ],
      cups:{}
    },
    lumasport_bra: {
      name:T("loose_006", "LumaSport BH"), handle:"lumasport-bh", url:"https://novyre.nl/products/lumasport-bh", type:"alpha_bra",
      ranges:[{s:"S",min:91.5,max:96.5},{s:"M",min:99,max:104},{s:"L",min:106.5,max:112},{s:"XL",min:114.5,max:119.5},{s:"XXL",min:124.5,max:129.5},{s:"3XL",min:132,max:137}],
      cups:{ "S":["70A","70B","70C","75A","75B"], "M":["70D","75C","75D","75E","80A","80B"], "L":["75E","75F","80C","80D","80E","80F","80G","85A","85B","85C"], "XL":["85D","85E","85F","85G","85H","90A","90B","90C","90D","90E","90F","90G","90H","95D","95E","95F","95G","95H","100A","100B","100C"], "XXL":["90H","95D","95E","95F","95G","95H","100D","100E"], "3XL":["100F","100G","105D","105E","105F","105G","105H","110D"] }
    },
    tanktop: {
      name:T("loose_007", "VitaSculpt Tanktop BH"), handle:"vitasculpt-tanktop-bh", url:"https://novyre.nl/products/vitasculpt-tanktop-bh", type:"alpha_bra",
      ranges:[{s:"S",min:86,max:95},{s:"M",min:96,max:104},{s:"L",min:104,max:112},{s:"XL",min:110,max:118},{s:"XXL",min:116,max:124},{s:"3XL",min:124,max:132}],
      cups:{ "S":["70C","70D","75A","75B","75C","75D","80A","80B"], "M":["80C","80D","85A","85B","85C","85D"], "L":["90A","90B","90C","90D"], "XL":["95A","95B","95C","95D"], "XXL":["100A","100B","100C","100D"], "3XL":["105A","105B","105C","105D"] }
    },
    pushup: { name:T("loose_008", "VitaSculpt Push-Up BH"), handle:"vitasculpt-push-up-bh-1", url:"https://novyre.nl/products/vitasculpt-push-up-bh-1", type:"brasize" },

    lumapure_string: { name:"LumaPure String", handle:"lumapure-string", url:"https://novyre.nl/products/lumapure-string", type:"alpha_bottom", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    contour_slip: { name:"Luma Contour Slip", handle:"luma-contour-slip", url:"https://novyre.nl/products/luma-contour-slip", type:"alpha_bottom", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    contour_short: { name:"Luma Contour Short", handle:"luma-contour-short", url:"https://novyre.nl/products/luma-contour-short", type:"alpha_bottom", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    lumashape_bodysuit: { name:"LumaShape Bodysuit", handle:"lumashape-bodysuit", url:"https://novyre.nl/products/lumashape-bodysuit", type:"alpha_shape", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    lumashape_corvia: { name:"LumaShape Corvia Bodysuit", handle:"lumashape-corvia-bodysuit", url:"https://novyre.nl/products/lumashape-corvia-bodysuit", type:"alpha_shape", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    lumashape_jumpsuit: { name:"LumaShape Jumpsuit", handle:"lumashape-jumpsuit", url:"https://novyre.nl/products/lumashape-jumpsuit", type:"alpha_shape", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    sport_legging: { name:"LumaSport Legging", handle:"lumasport-legging", url:"https://novyre.nl/products/lumasport-legging", type:"alpha_bottom", ranges_bottom:[{s:"S",waist:[60,69],hip:[86,95]},{s:"M",waist:[70,79],hip:[96,104]},{s:"L",waist:[80,89],hip:[105,112]},{s:"XL",waist:[90,99],hip:[113,120]},{s:"XXL",waist:[100,109],hip:[121,128]},{s:"3XL",waist:[110,120],hip:[129,138]}] },
    sport_zip: { name:"LumaSport Zip", handle:"lumasport-zip", url:"https://novyre.nl/products/lumasport-zip", type:"alpha_top", ranges_top:[{s:"S",chest:[84,92]},{s:"M",chest:[93,100]},{s:"L",chest:[101,108]},{s:"XL",chest:[109,116]},{s:"XXL",chest:[117,124]},{s:"3XL",chest:[125,134]}] },
    badpak: { name:"LumaShape Badpak", handle:"lumashape-badpak", url:"https://novyre.nl/products/lumashape-badpak", type:"alpha_swim", length_label:"Center Back Length (in)", ranges_swim:[{s:"S",bust_in:"34-36",waist_in:"27-29",hip_in:"36-38",length_in:"17.3"},{s:"M",bust_in:"36-38",waist_in:"29-31",hip_in:"38-40",length_in:"17.7"},{s:"L",bust_in:"38-40",waist_in:"32-34.5",hip_in:"41-43",length_in:"18.1"},{s:"XL",bust_in:"40-42.5",waist_in:"35.5-38",hip_in:"43.5-46",length_in:"18.5"},{s:"XXL",bust_in:"42.5-45",waist_in:"39-42",hip_in:"46.5-49",length_in:"18.9"},{s:"3XL",bust_in:"45-47.5",waist_in:"43-46",hip_in:"49.5-52",length_in:"19.3"}], ranges_bottom:[{s:"S",waist:[68,74],hip:[91,97]},{s:"M",waist:[74,79],hip:[97,102]},{s:"L",waist:[81,88],hip:[104,109]},{s:"XL",waist:[90,97],hip:[110,117]},{s:"XXL",waist:[99,107],hip:[118,124]},{s:"3XL",waist:[109,117],hip:[126,132]}] },
    bikini: { name:"LumaShape Bikini Set", handle:"lumashape-bikini-set", url:"https://novyre.nl/products/lumashape-bikini-set", type:"alpha_swim", length_label:"Strap Length (in)", ranges_swim:[{s:"S",bust_in:"34-36",waist_in:"27-29",hip_in:"36-38",length_in:"6.7"},{s:"M",bust_in:"36-38",waist_in:"29-31",hip_in:"38-40",length_in:"6.7"},{s:"L",bust_in:"38-40",waist_in:"32-34.5",hip_in:"41-43",length_in:"7.5"},{s:"XL",bust_in:"40-42.5",waist_in:"35.5-38",hip_in:"43.5-46",length_in:"7.5"},{s:"XXL",bust_in:"42.5-45",waist_in:"39-42",hip_in:"46.5-49",length_in:"8.3"},{s:"3XL",bust_in:"45-47.5",waist_in:"43-46",hip_in:"49.5-52",length_in:"8.3"}], ranges_bottom:[{s:"S",waist:[68,74],hip:[91,97]},{s:"M",waist:[74,79],hip:[97,102]},{s:"L",waist:[81,88],hip:[104,109]},{s:"XL",waist:[90,97],hip:[110,117]},{s:"XXL",waist:[99,107],hip:[118,124]},{s:"3XL",waist:[109,117],hip:[126,132]}] }
  };

  /* Marktbewuste product-URL's: nooit een hardcoded hostname. De actieve markt-root
     (routes.root_url) komt via de i18n-payload binnen; zonder payload blijft '/'. */
  (function(){
    const root = String(T('__root','/')).replace(/\/+$/,'');
    for (const k in PRODUCTS) {
      const p = PRODUCTS[k];
      if (p && p.handle) p.url = root + '/products/' + p.handle;
    }
  })();

  // ------------------------------------------------------------------------------
  //  4) MATCHING — v6 herschreven: ALLE 5 BH-producten worden ALTIJD geëvalueerd
  // ------------------------------------------------------------------------------
  const findSizeByCupRaw = (productKey, bra) => {
    const cleanBra = normalizeBra(bra);
    if (productKey === "forma") return getFormaSizeFromChart(cleanBra);
    const product = PRODUCTS[productKey];
    const cupsData = (product && product.cups) ? product.cups : {};
    const orderFromRanges = (product && Array.isArray(product.ranges) && product.ranges.length)
      ? product.ranges.map(r => r.s) : Object.keys(cupsData);
    const hits = [];
    for (const size of orderFromRanges) {
      const arr = Array.isArray(cupsData[size]) ? cupsData[size] : [];
      if (arr.map(normalizeBra).includes(cleanBra)) hits.push(size);
    }
    if (productKey === "contour") {
      const advice = getContourAdviceFromBra(cleanBra);
      return advice ? advice.size : null;
    }
    return hits.length ? hits[0] : null;
  };

  // v9.4: Contour heeft zeer soepele, vormvolgende cups. De cupletter is
  // geen harde uitsluiting: ook 75H/75I en hogere cupdruk kunnen fysiek passen.
  // De maat wordt bepaald door de grootste minimumvereiste van:
  // 1) de onderband en 2) de totale borstomvang.
  const ALPHA_SIZE_ORDER = ["S","M","L","XL","XXL"];

  // Halve-centimetergrenzen voorkomen meetgaten bij decimalen.
  const contourSizeByUnder = (under) => {
    const u = Number(under);
    if (!Number.isFinite(u) || u < 68 || u > 112.5) return null;
    if (u < 77.5) return "S";
    if (u < 86.5) return "M";
    if (u < 95.5) return "L";
    if (u < 104.5) return "XL";
    return "XXL";
  };

  const contourSizeByBust = (bust) => {
    const b = Number(bust);
    if (!Number.isFinite(b) || b <= 0 || b > 140) return null;
    if (b <= 97) return "S";
    if (b <= 105) return "M";
    if (b <= 112) return "L";
    if (b <= 119) return "XL";
    return "XXL";
  };

  const CONTOUR_TABLE_ROWS = [
    {s:"S",under:"68–77 cm",bust:"t/m 97 cm"},
    {s:"M",under:"78–86 cm",bust:"98–105 cm"},
    {s:"L",under:"87–95 cm",bust:"106–112 cm"},
    {s:"XL",under:"96–104 cm",bust:"113–119 cm"},
    {s:"XXL",under:"105–112 cm",bust:"120–140 cm"}
  ];

  const largerAlphaSize = (a,b) => {
    if (!a || !b) return null;
    const ai = ALPHA_SIZE_ORDER.indexOf(a);
    const bi = ALPHA_SIZE_ORDER.indexOf(b);
    if (ai < 0 || bi < 0) return null;
    return ALPHA_SIZE_ORDER[Math.max(ai,bi)] || null;
  };

  const getContourMeasuredAdvice = (under,bust,cup) => {
    const u = Number(under), b = Number(bust);
    if (!Number.isFinite(u) || !Number.isFinite(b) || b <= u) return null;

    const sizeByUnder = contourSizeByUnder(u);
    const sizeByBust = contourSizeByBust(b);
    if (!sizeByUnder || !sizeByBust) return null;

    const size = largerAlphaSize(sizeByUnder,sizeByBust);
    if (!size) return null;

    const normalizedCup = String(cup || "").toUpperCase();
    const cupIPlus = normalizedCup && cupAtLeast(normalizedCup,"I");
    const cupGPlus = normalizedCup && cupAtLeast(normalizedCup,"G");
    const volumeUpsize =
      ALPHA_SIZE_ORDER.indexOf(sizeByBust) > ALPHA_SIZE_ORDER.indexOf(sizeByUnder);
    const bandUpsize =
      ALPHA_SIZE_ORDER.indexOf(sizeByUnder) > ALPHA_SIZE_ORDER.indexOf(sizeByBust);

    let confidence = "calibrated_2d";
    let hint;

    if (cupIPlus) {
      confidence = "comfort_very_high_cup";
      hint = T("de_soepele_cup_vormt_mee_met", "De soepele cup vormt mee met dit borstvolume. Dit is een comfortmatch; verwacht een natuurlijkere vorm en minder lift dan bij de Forma.");
    } else if (cupGPlus) {
      confidence = "comfort_high_cup";
      hint = T("de_flexibele_cup_kan_dit_borstvolume", "De flexibele cup kan dit borstvolume opnemen. Kies Contour voor zacht comfort; Forma geeft doorgaans meer gevormde lift.");
    } else if (volumeUpsize) {
      hint = T("een_maat_ruimer_gekozen_voor_voldoende", "Eén maat ruimer gekozen voor voldoende ruimte over de borst, terwijl de onderband courant blijft.");
    } else if (bandUpsize) {
      hint = T("de_maat_wordt_door_de_onderband", "De maat wordt door de onderband bepaald, zodat de BH niet te strak valt.");
    } else {
      hint = T("maat_bepaald_op_onderborst_en_totale", "Maat bepaald op onderborst én totale borstomvang.");
    }

    return { size, sizeByUnder, sizeByBust, confidence, hint };
  };

  const getContourAdviceFromBra = (braString) => {
    const p = parseBra(braString);
    if (!p) return null;
    const bust = estimateBustCmFromBra(`${p.band}${p.cup}`);
    return getContourMeasuredAdvice(p.band,bust,p.cup);
  };

  const matchBottomSize = (waist, hip, ranges) => {
    const hits = [];
    for (const r of (ranges || [])) {
      const okWaist = !waist ? true : (waist >= r.waist[0] && waist <= r.waist[1]);
      const okHip = !hip ? true : (hip >= r.hip[0] && hip <= r.hip[1]);
      if (okWaist && okHip) hits.push(r.s);
    }
    if (hits.length) return hits[0];
    if (hip) {
      let best=null, bestDist=Infinity;
      for (const r of (ranges||[])) { const mid=(r.hip[0]+r.hip[1])/2; const d=Math.abs(hip-mid); if (d<bestDist){bestDist=d;best=r.s;} }
      return best;
    }
    if (waist) {
      let best=null, bestDist=Infinity;
      for (const r of (ranges||[])) { const mid=(r.waist[0]+r.waist[1])/2; const d=Math.abs(waist-mid); if (d<bestDist){bestDist=d;best=r.s;} }
      return best;
    }
    return null;
  };

  const matchTopSize = (chest, rangesTop) => {
    if (!chest) return null;
    for (const r of (rangesTop||[])) if (chest >= r.chest[0] && chest <= r.chest[1]) return r.s;
    let best=null, bestDist=Infinity;
    for (const r of (rangesTop||[])) { const mid=(r.chest[0]+r.chest[1])/2; const d=Math.abs(chest-mid); if (d<bestDist){bestDist=d;best=r.s;} }
    return best;
  };

  // v9.4 multi-fit engine: Forma exact/gekalibreerd, Contour 2D,
  // overige modellen uitsluitend bij een exacte beschikbare maat.
  const getMatchingProductsByBra = (bra, currentProductKey, quizRecKey, options = {}) => {
    const cleanBra = normalizeBra(bra);
    const parts = parseBra(cleanBra);
    if (!parts) return [];
    const euBra = `${parts.band}${parts.cup}`;
    const matches = [];
    const measured = !!options.measured;
    const formaCell = getFormaCellAdvice(parts.band,parts.cup);
    const formaSize = formaCell ? formaCell.size : null;

    if (formaSize) {
      let formaHint;
      if (formaCell.confidence === "manufacturer_exact") {
        formaHint = measured
          ? T("eubra_staat_exact_in_de_forma", "%bra% staat exact in de Forma-fabrikantkaart.").replace("%bra%", euBra)
          : T("exacte_fabrikantmatch_op_basis_van_je", "Exacte fabrikantmatch op basis van je BH-maat. Meten blijft nauwkeuriger.");
      } else if (formaCell.confidence === "calibrated_110") {
        formaHint = T("eubra_valt_in_de_gekalibreerde_band", "%bra% valt in de gekalibreerde band-110-range; gebruik de extender.").replace("%bra%", euBra);
      } else {
        formaHint = T("eubra_valt_in_de_gekalibreerde_band_2", "%bra% valt in de gekalibreerde band-115-range; gebruik de extender.").replace("%bra%", euBra);
      }
      matches.push({ key:"forma",size:formaSize,score:currentProductKey === "forma" ? 110 : 90,hint:formaHint });
    }

    const contourAdvice = measured && options.profile
      ? getContourMeasuredAdvice(options.profile.under,options.profile.bust,options.profile.cup)
      : getContourAdviceFromBra(euBra);
    if (contourAdvice) {
      const isFallback = measured && !formaSize;
      const isBandEdgeAlternative = measured && !!formaSize && !!options.formaAdvice?.profile?.bandEdge;
      matches.push({
        key:"contour",
        size:contourAdvice.size,
        score:currentProductKey === "contour" ? 108 : (isFallback ? 100 : 82),
        hint:isFallback
          ? T("beste_flexibele_alternatief_contouradvice_hint_beste", "Beste flexibele alternatief. %hint%").replace("%hint%", contourAdvice.hint)
          : isBandEdgeAlternative
            ? T("zachter_alternatief_op_de_bandgrens_contouradvice", "Zachter alternatief op de bandgrens. %hint%").replace("%hint%", contourAdvice.hint)
            : contourAdvice.hint
      });
    }

    if (PUSHUP_VALID.has(euBra)) {
      matches.push({ key:"pushup",size:euBra,score:currentProductKey === "pushup" ? 106 : (measured && !formaSize ? 94 : 84),
        hint:T("exacte_bh_maat_met_lift_en", "Exacte BH-maat met lift en een lagere halslijn.") });
    }

    const tankSize = findSizeByCupRaw("tanktop",euBra);
    if (tankSize) {
      matches.push({ key:"tanktop",size:tankSize,score:currentProductKey === "tanktop" ? 106 : (measured && !formaSize ? 96 : 76),
        hint:T("exacte_maatmatch_met_meer_bedekking_en", "Exacte maatmatch met meer bedekking en smoothing.") });
    }

    if (!cupVeryHigh(parts.cup)) {
      const sportSize = findSizeByCupRaw("lumasport_bra",euBra);
      if (sportSize) matches.push({ key:"lumasport_bra",size:sportSize,score:currentProductKey === "lumasport_bra" ? 104 : 70,
        hint:T("voor_sport_met_meer_grip_en", "Voor sport, met meer grip en stabiliteit bij bewegen.") });
    }

    if (quizRecKey) matches.forEach(m => { if (m.key === quizRecKey) m.score += 6; });
    matches.sort((a,b) => (b.score-a.score) || ((b.key===currentProductKey?1:0)-(a.key===currentProductKey?1:0)));
    return matches;
  };


  const validateFitSafeEngine = () => {
    if (window.__NVYU_V94_VALIDATED__) return;
    window.__NVYU_V94_VALIDATED__ = true;
    const failures = [];
    const allowedFormaSizes = new Set(["XS","S","S+","M","M+","L","L+","XL","XL+","XXL","XXL+","3XL","3XL+"]);

    // 1) Alle officiële fabrikantcellen moeten 1-op-1 terugkomen.
    Object.entries(FORMA_OFFICIAL_BAND_TO_COL).forEach(([bandRaw,col]) => {
      const band = Number(bandRaw);
      ["A","B","C","D","E","F","G","H","I","J","K"].forEach(cup => {
        const expected = (FORMA_OFFICIAL_CHART[cup] && FORMA_OFFICIAL_CHART[cup][col]) || null;
        const got = getFormaCellAdvice(band,cup);
        const gotSize = got ? got.size : null;
        if (gotSize !== expected) failures.push({type:"official_cell",band,cup,expected,got:gotSize});
        if (gotSize && !allowedFormaSizes.has(gotSize)) failures.push({type:"invalid_variant",band,cup,got:gotSize});
      });
    });

    // 2) Gekalibreerde bovengrens is expliciet en mag nergens uitbreiden.
    const calibratedExpected = {
      "110C":"XXL","110D":"3XL","110E":"3XL","110F":"3XL","110G":"3XL+","110H":"3XL+",
      "115D":"3XL","115E":"3XL","115F":"3XL","115G":"3XL+","115H":"3XL+"
    };
    [110,115].forEach(band => {
      ["A","B","C","D","E","F","G","H","I","J","K"].forEach(cup => {
        const expected = calibratedExpected[`${band}${cup}`] || null;
        const got = getFormaCellAdvice(band,cup);
        const gotSize = got ? got.size : null;
        if (gotSize !== expected) failures.push({type:"calibrated_cell",band,cup,expected,got:gotSize});
      });
    });

    // 3) Kritische regressiegevallen.
    const cases = [
      {u:94,b:110,bra:"95B",forma:"L",contour:"L"},
      {u:78,b:100,bra:"80E",forma:"M+",contour:"M"},
      {u:86,b:109,bra:"85F",forma:"XL",contour:"L"},
      {u:90,b:114,bra:"90F",forma:"XL+",contour:"XL"},
      {u:95,b:115,bra:"95D",forma:"XL",contour:"XL"},
      {u:95,b:116,bra:"95E",forma:"XL",contour:"XL"},
      {u:95,b:119,bra:"95F",forma:"XXL",contour:"XL"},
      {u:95,b:120,bra:"95G",forma:"XXL+",contour:"XXL"},
      {u:95,b:121,bra:"95G",forma:"XXL+",contour:"XXL"},
      {u:98,b:116,bra:"100C",forma:"XXL",contour:"XL"},
      {u:100,b:117,bra:"100C",forma:"XXL",contour:"XL"},
      {u:100,b:121,bra:"100E",forma:"XXL",contour:"XXL"},
      {u:98,b:103,bra:"100AA",forma:null,contour:"XL"},
      {u:75,b:102,bra:"75H",forma:null,contour:"M"},
      {u:75,b:104,bra:"75I",forma:null,contour:"M"},
      {u:75,b:108,bra:"75K",forma:null,contour:"L"},
      {u:93,b:127,bra:"95K",forma:null,contour:"XXL"},
      {u:110,b:127,bra:"110C",forma:"XXL",contour:"XXL"},
      {u:110,b:129,bra:"110D",forma:"3XL",contour:"XXL"},
      {u:110,b:135,bra:"110G",forma:"3XL+",contour:"XXL"},
      {u:110,b:137,bra:"110H",forma:"3XL+",contour:"XXL"},
      {u:115,b:135,bra:"115D",forma:"3XL",contour:null},
      {u:115,b:141,bra:"115G",forma:"3XL+",contour:null},
      {u:115,b:130,bra:"115B",forma:null,contour:null}
    ];
    cases.forEach(c => {
      const p = getMeasuredBraProfile(c.u,c.b);
      const f = getFormaMeasuredAdvice(c.u,c.b);
      const ca = p ? getContourMeasuredAdvice(p.under,p.bust,p.cup) : null;
      const contour = ca ? ca.size : null;
      if (!p || p.bra !== c.bra || f.size !== c.forma || contour !== c.contour) {
        failures.push({type:"regression",expected:c,got:{bra:p&&p.bra,forma:f&&f.size,contour}});
      }
    });

    // 4) Contour moet monotoon zijn: meer omvang mag nooit een kleinere maat geven.
    let prevUnderSize = -1;
    for (let under=68; under<=112; under++) {
      const a = getContourMeasuredAdvice(under,Math.max(under+10,100),"D");
      if (!a) continue;
      const idx = ALPHA_SIZE_ORDER.indexOf(a.size);
      if (idx < prevUnderSize) failures.push({type:"contour_under_non_monotonic",under,size:a.size});
      prevUnderSize = Math.max(prevUnderSize,idx);
    }
    for (let under=68; under<=112; under++) {
      let prev=-1;
      for (let bust=Math.max(under+1,85); bust<=140; bust++) {
        const a = getContourMeasuredAdvice(under,bust,"D");
        if (!a) continue;
        const idx = ALPHA_SIZE_ORDER.indexOf(a.size);
        if (idx < prev) failures.push({type:"contour_bust_non_monotonic",under,bust,size:a.size});
        prev = Math.max(prev,idx);
      }
    }

    // 5) Contour-grenswaarden met decimalen.
    const contourBoundaryCases = [
      {u:95.49,b:110,expected:"L"},
      {u:95.50,b:110,expected:"XL"},
      {u:104.49,b:119,expected:"XL"},
      {u:104.50,b:119,expected:"XXL"},
      {u:75,b:97,expected:"S"},
      {u:75,b:97.01,expected:"M"},
      {u:75,b:112,expected:"L"},
      {u:75,b:112.01,expected:"XL"},
      {u:75,b:119,expected:"XL"},
      {u:75,b:119.01,expected:"XXL"},
      {u:110,b:140,expected:"XXL"}
    ];
    contourBoundaryCases.forEach(c => {
      const a = getContourMeasuredAdvice(c.u,c.b,"D");
      const got = a ? a.size : null;
      if (got !== c.expected) failures.push({type:"contour_boundary",expected:c,got});
    });

    // 6) Volledige cm-grid: elk Forma-resultaat moet exact uit één vastgelegde cel komen.
    for (let under=55; under<=125; under++) {
      for (let diff=4; diff<=40; diff++) {
        const bust=under+diff;
        const p=getMeasuredBraProfile(under,bust);
        const a=getFormaMeasuredAdvice(under,bust);
        if (!p) continue;
        const direct=p.overflow?null:getFormaCellAdvice(p.band,p.cup);
        const directSize=direct?direct.size:null;
        if (a.size!==directSize) failures.push({type:"grid_mismatch",under,bust,bra:p.bra,advice:a.size,direct:directSize});
        if (a.size&&!allowedFormaSizes.has(a.size)) failures.push({type:"grid_invalid_size",under,bust,size:a.size});
      }
    }

    const report={ok:failures.length===0,failures,count:failures.length,version:"9.4"};
    window.__NVYU_FIT_VALIDATION_V94__=report;
    if (failures.length) console.error("[NVY v9.4 FIT ENGINE] validatiefouten",failures);
    else console.info("[NVY v9.4 FIT ENGINE] validatie geslaagd: Forma ongewijzigd, retourveilige 2D Contour, hoge cups en cm-grid.");
  };

  // ------------------------------------------------------------------------------
  //  5) MARKUP
  // ------------------------------------------------------------------------------
  const renderMarkup = (sid) => {
    const pinSvg = `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>`;
    const checkSmallSvg = `<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
    const arrowRightSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>`;
    const checkSvg = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    return `
      <div class="nvyU__trigger-wrapper">
        <button type="button" class="nvyU__trigger-btn" data-nvyu-open aria-label="${T("open_de_novyre_maattool", 'Open de Novyre maattool')}">
          <div class="nvyU__trigger-icon">${pinSvg}</div>
          <div class="nvyU__trigger-content">
            <div class="nvyU__trigger-row">
              <span class="nvyU__trigger-title">${T("vind_jouw_novyre_maat", "Vind jouw Novyre maat")}</span>
              <span class="nvyU__trigger-badge">${checkSmallSvg} ${T("aanbevolen", "Aanbevolen")}</span>
            </div>
            <span class="nvyU__trigger-sub">${T("welk_model_en_welke_maat_bij", "Welk model én welke maat bij je past, in 2 minuten.")}</span>
          </div>
          <div class="nvyU__trigger-arrow">${arrowRightSvg}</div>
        </button>
      </div>

      <div class="nvyU__modal" aria-hidden="true" data-nvyu-modal>
        <div class="nvyU__overlay" data-nvyu-close></div>
        <div class="nvyU__panel" role="dialog" aria-modal="true" aria-label="${T("novyre_maattool", 'Novyre maattool')}">
          <div class="nvyU__top">
            <div class="nvyU__brand">NOVYRE</div>
            <button class="nvyU__close" type="button" aria-label="${T("sluiten", 'Sluiten')}" data-nvyu-close>×</button>
          </div>

          <div class="nvyU__hero">
            <div class="nvyU__heroText">
              <h2 class="nvyU__title" data-nvyu-hero-title></h2>
              <p class="nvyU__sub" data-nvyu-hero-sub></p>
            </div>
            <div class="nvyU__heroProof">
              <span class="nvyU__proof">${checkSvg} ${T("14_dagen_thuis_passen", "14 dagen thuis passen")}</span>
              <span class="nvyU__proof">${checkSvg} ${T("shipping", "€3,95 verzending · gratis vanaf €50")}</span>
              <span class="nvyU__proof">${checkSvg} ${T("klaar_in_1_minuut", "Klaar in 2 minuten")}</span>
            </div>
            <div class="nvyU__heroActions" data-nvyu-hero-actions>
              <button type="button" class="nvyU__bigBtn nvyU__bigBtn--primary" data-nvyu-goto="meten">${T("meet_mijn_maat_in_1_minuut", "Meet mijn maat in 2 minuten")}</button>
              <button type="button" class="nvyU__bigBtn nvyU__bigBtn--ghost" data-nvyu-goto="snel">${T("ik_weet_mijn_maat_al", "Ik weet mijn maat al")}</button>
            </div>
            <div class="nvyU__heroNudge">${T("zo_zit_je_nieuwe_bh_in", "Zo zit je nieuwe BH in één keer écht lekker.")}</div>
          </div>

          <div class="nvyU__tabs" role="tablist" data-nvyu-tabs>
            <button type="button" class="nvyU__tab is-active" role="tab" data-nvyu-tab="snel" data-nvyu-tabbtn="snel">${T("snel", "Snel")}</button>
            <button type="button" class="nvyU__tab" role="tab" data-nvyu-tab="meten" data-nvyu-tabbtn="meten">${T("meten", "Meten")}</button>
            <button type="button" class="nvyU__tab" role="tab" data-nvyu-tab="kaart" data-nvyu-tabbtn="kaart">${T("maatkaart", "Maatkaart")}</button>
            <button type="button" class="nvyU__tab" role="tab" data-nvyu-tab="quiz" data-nvyu-tabbtn="quiz">${T("keuzehulp", "Keuzehulp")} <span class="nvyU__tabBadge">${T("aanrader", "Aanrader")}</span></button>
          </div>

          <div class="nvyU__content">
            <section class="nvyU__section is-active" data-nvyu-pane="snel" data-nvyu-paneel="snel">
              <div class="nvyU__card">
                <div class="nvyU__cardTitle" data-nvyu-fast-title></div>
                <div class="nvyU__field">
                  <label class="nvyU__label" for="nvyu-bra-${sid}" data-nvyu-fast-label>${T("bh_maat", "BH-maat")}</label>
                  <input id="nvyu-bra-${sid}" class="nvyU__input" type="text" inputmode="text" autocapitalize="characters" placeholder="${T("bijv_85e", 'Bijv. 85E')}" data-nvyu-fast-input />
                  <div class="nvyU__mini" data-nvyu-fast-tip></div>
                  <button type="button" class="nvyU__linkBtn" data-nvyu-goto="meten">${T("waar_meet_ik_bekijk_de_meetgids", "Waar meet ik? Bekijk de meetgids →")}</button>
                </div>
                <div class="nvyU__microCheck" data-nvyu-microcheck style="display:none">
                  <div class="nvyU__microTitle">${T("twijfel_je_of_je_maat_klopt", "Twijfel je of je maat klopt?")}</div>
                  <div class="nvyU__chips" role="group">
                    <button type="button" class="nvyU__chip" data-nvyu-symptom="band_up">${T("band_kruipt_omhoog", "Band kruipt omhoog")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-symptom="spill">${T("cup_snijdt_of_puilt", "Cup snijdt of puilt")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-symptom="straps">${T("bandjes_snijden", "Bandjes snijden")}</button>
                  </div>
                  <div class="nvyU__nudge" data-nvyu-nudge style="display:none">
                    <span><strong>${T("betere_route", "Betere route:")}</strong> ${T("meet_1_minuut_dan_weet_je", "meet 2 minuten, dan weet je het zeker.")}</span>
                    <button type="button" class="nvyU__btn nvyU__btn--primary" data-nvyu-goto="meten">${T("meten", "Meten")}</button>
                  </div>
                </div>
                <div class="nvyU__result" data-nvyu-result-fast aria-live="polite"></div>
                <div class="nvyU__ageCheck" data-nvyu-agecheck style="display:none">
                  <div class="nvyU__ageRow">
                    <div class="nvyU__microTitle" data-nvyu-agecheck-title></div>
                    <div class="nvyU__chips" role="group">
                      <button type="button" class="nvyU__chip" data-nvyu-age="recent">${T("recent", "Recent")}</button>
                      <button type="button" class="nvyU__chip" data-nvyu-age="older">${T("langer_geleden", "Langer geleden")}</button>
                    </div>
                  </div>
                  <div data-nvyu-agecheck-msg></div>
                </div>
                <div class="nvyU__matchCards" data-nvyu-cards-fast></div>
              </div>
            </section>

            <section class="nvyU__section" data-nvyu-pane="meten" data-nvyu-paneel="meten">
              <div class="nvyU__card">
                <div class="nvyU__cardTitle" data-nvyu-measure-title></div>
                <div class="nvyU__mini" data-nvyu-measure-sub></div>
                <div class="nvyU__measureGrid">
                  <div class="nvyU__measureFigWrap" data-nvyu-figwrap>
                    <div class="nvyU__measureFig" data-nvyu-fig></div>
                    <div class="nvyU__figCaption" data-nvyu-fig-cap></div>
                  </div>
                  <div class="nvyU__measureFields">
                    <div class="nvyU__field" data-nvyu-field-a>
                      <label class="nvyU__label" for="nvyu-under-${sid}" data-nvyu-label-a></label>
                      <input id="nvyu-under-${sid}" class="nvyU__input" type="number" inputmode="numeric" min="0" max="200" step="1" data-nvyu-a />
                      <div class="nvyU__mini" data-nvyu-hint-a></div>
                    </div>
                    <div class="nvyU__field" data-nvyu-field-b>
                      <label class="nvyU__label" for="nvyu-bust-${sid}" data-nvyu-label-b></label>
                      <input id="nvyu-bust-${sid}" class="nvyU__input" type="number" inputmode="numeric" min="0" max="250" step="1" data-nvyu-b />
                      <div class="nvyU__mini" data-nvyu-hint-b></div>
                    </div>
                  </div>
                </div>
                <div class="nvyU__result" data-nvyu-result-measure aria-live="polite"></div>
                <div class="nvyU__matchCards" data-nvyu-cards-measure></div>
              </div>
            </section>

            <section class="nvyU__section" data-nvyu-pane="kaart" data-nvyu-paneel="kaart">
              <div class="nvyU__card">
                <div class="nvyU__cardTitle" data-nvyu-table-title></div>
                <div class="nvyU__tableWrap" role="region">
                  <table class="nvyU__table">
                    <thead data-nvyu-tablehead></thead>
                    <tbody data-nvyu-tablebody></tbody>
                  </table>
                </div>
                <div class="nvyU__hintline" data-nvyu-table-hint></div>
              </div>
            </section>

            <section class="nvyU__section" data-nvyu-pane="quiz" data-nvyu-paneel="quiz">
              <div class="nvyU__card">
                <div class="nvyU__cardTitle">${T("welk_model_past_beter_bij_jou", "Welk model past beter bij jou?")}</div>
                <div class="nvyU__mini">${T("korte_keuzehulp_als_je_twijfelt_tussen", "Korte keuzehulp als je twijfelt tussen meerdere Novyre BH's.")}</div>
                <div class="nvyU__q">
                  <div class="nvyU__qTitle">${T("1_wat_wil_je_vooral", "1) Wat wil je vooral?")}</div>
                  <div class="nvyU__chips">
                    <button type="button" class="nvyU__chip" data-nvyu-q="pain" data-nvyu-a="pressure">${T("minder_druk_knellen", "Minder druk / knellen")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="pain" data-nvyu-a="shape">${T("meer_vorm", "Meer vorm")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="pain" data-nvyu-a="bounce">${T("meer_stabiliteit", "Meer stabiliteit")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="pain" data-nvyu-a="smooth">${T("meer_bedekking", "Meer bedekking")}</button>
                  </div>
                </div>
                <div class="nvyU__q">
                  <div class="nvyU__qTitle">${T("2_hoe_moet_de_bh_voelen", "2) Hoe moet de BH voelen?")}</div>
                  <div class="nvyU__chips">
                    <button type="button" class="nvyU__chip" data-nvyu-q="feel" data-nvyu-a="natural">${T("zo_licht_mogelijk", "Zo licht mogelijk")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="feel" data-nvyu-a="support">${T("meer_ondersteuning", "Meer ondersteuning")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="feel" data-nvyu-a="firm">${T("steviger_strakker", "Steviger / strakker")}</button>
                  </div>
                </div>
                <div class="nvyU__q">
                  <div class="nvyU__qTitle">${T("3_welke_halslijn_draag_je_vaker", "3) Welke halslijn draag je vaker?")}</div>
                  <div class="nvyU__chips">
                    <button type="button" class="nvyU__chip" data-nvyu-q="neck" data-nvyu-a="low">${T("v_hals_laag", "V-hals / laag")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="neck" data-nvyu-a="normal">${T("normaal_hoog", "Normaal / hoog")}</button>
                  </div>
                </div>
                <div class="nvyU__q" data-nvyu-branch="nipple" style="display:none">
                  <div class="nvyU__qTitle">${T("4_tepels_licht_zichtbaar_oke", "4) Tepels licht zichtbaar: oké?")}</div>
                  <div class="nvyU__chips">
                    <button type="button" class="nvyU__chip" data-nvyu-q="nipple" data-nvyu-a="ok">${T("geen_probleem", "Geen probleem")}</button>
                    <button type="button" class="nvyU__chip" data-nvyu-q="nipple" data-nvyu-a="prefer_not">${T("liever_niet", "Liever niet")}</button>
                  </div>
                </div>
                <div class="nvyU__result" data-nvyu-result-quiz aria-live="polite">${T("beantwoord_de_vragen_voor_modeladvies", "Beantwoord de vragen voor modeladvies.")}</div>
                <div class="nvyU__matchCards" data-nvyu-cards-quiz></div>
                <div class="nvyU__hintline">${T("daarna_kun_je_direct_je_maat", "Daarna kun je direct je maat invullen of meten.")}</div>
              </div>
            </section>
          </div>

          <div class="nvyU__bottomBar" data-nvyu-sticky>
            <div class="nvyU__stickyMeta">
              <div class="nvyU__stickyTitle" data-nvyu-sticky-title>${T("vul_je_maat_in_voor_jouw", "Vul je maat in voor jouw beste match")}</div>
              <div class="nvyU__stickySub" data-nvyu-sticky-sub>${T("fit_days_shipping", "14 dagen passen · €3,95 verzending · gratis vanaf €50")}</div>
            </div>
            <div class="nvyU__stickyCta" data-nvyu-sticky-cta>
              <button type="button" class="nvyU__btn nvyU__btn--ghost" data-nvyu-close>${T("sluiten", "Sluiten")}</button>
            </div>
          </div>

        </div>
      </div>
    `;
  };

  // ------------------------------------------------------------------------------
  //  6) INIT
  // ------------------------------------------------------------------------------
  window.__NVYU_INIT_ALL__ = function () {
    injectCustomStyles();
    ensureRootExists();
    validateFitSafeEngine();

    const roots = document.querySelectorAll("[data-nvyu-root]");
    roots.forEach((root) => {
      if (!root) return;
      if (root.dataset.nvyuInit === "1") return;

      const sid = root.getAttribute("data-nvyu-root") || "nvyu";
      const currentHandle = root.getAttribute("data-current-handle") || "";
      let mode = (root.getAttribute("data-nvy-mode") || "bra").toLowerCase();

      const hLow = currentHandle.toLowerCase();
      if (hLow.includes('badpak') || hLow.includes('bikini') || hLow.includes('zwem') || hLow.includes('badkleding') || hLow.includes('badmode')) mode = "swim";

      const trackingEnabled = root.getAttribute("data-track-enabled") === "1";
      const trackPrefix = root.getAttribute("data-track-prefix") || "novyre_size";
      const LS_KEY = "nvy_size_tool_state_v7";

      const track = (name, params = {}) => {
        if (!trackingEnabled) return;
        const eventName = `${trackPrefix}_${name}`;
        const payload = Object.assign({ event: eventName }, params);
        if (window.dataLayer && typeof window.dataLayer.push === "function") window.dataLayer.push(payload);
        if (typeof window.gtag === "function") { const gp = Object.assign({}, params); delete gp.event; window.gtag("event", eventName, gp); }
      };

      const detectProductKeyFromHandle = () => {
        const pathHandle = ((window.location.pathname || "").match(/\/products\/([^/?#]+)/) || [])[1] || "";
        const resolvedHandle = (currentHandle || pathHandle).toLowerCase();
        for (const k in PRODUCTS) if (PRODUCTS[k].handle === resolvedHandle) return k;
        const h = resolvedHandle;
        if (h.includes('badpak')) return "badpak";
        if (h.includes('bikini')) return "bikini";
        if (h.includes('zwem') || h.includes('badkleding') || h.includes('badmode')) return "badpak";
        if (mode === "bra") return "forma";
        if (mode === "slip") return "contour_slip";
        if (mode === "string") return "lumapure_string";
        if (mode === "short") return "contour_short";
        if (mode === "shapewear") return "lumashape_corvia";
        if (mode === "sport") return "sport_legging";
        if (mode === "swim") return "badpak";
        return "forma";
      };

      const currentProductKey = detectProductKeyFromHandle();

      root.innerHTML = renderMarkup(sid);
      root.dataset.nvyuInit = "1";

      if (PRODUCTS[currentProductKey]) fetchProductImage(PRODUCTS[currentProductKey].handle);

      const modal = root.querySelector("[data-nvyu-modal]");
      const openBtn = root.querySelector("[data-nvyu-open]");
      const closeEls = root.querySelectorAll("[data-nvyu-close]");
      const tabs = [...root.querySelectorAll("[data-nvyu-tab]")];
      const panes = [...root.querySelectorAll("[data-nvyu-pane]")];
      const gotoBtns = [...root.querySelectorAll("[data-nvyu-goto]")];
      const heroTitle = root.querySelector("[data-nvyu-hero-title]");
      const heroSub = root.querySelector("[data-nvyu-hero-sub]");
      const heroActions = root.querySelector("[data-nvyu-hero-actions]");
      const fastTitle = root.querySelector("[data-nvyu-fast-title]");
      const fastTip = root.querySelector("[data-nvyu-fast-tip]");
      const measureTitle = root.querySelector("[data-nvyu-measure-title]");
      const measureSub = root.querySelector("[data-nvyu-measure-sub]");
      const labelA = root.querySelector("[data-nvyu-label-a]");
      const labelB = root.querySelector("[data-nvyu-label-b]");
      const hintA = root.querySelector("[data-nvyu-hint-a]");
      const hintB = root.querySelector("[data-nvyu-hint-b]");
      const fieldB = root.querySelector("[data-nvyu-field-b]");
      const figWrap = root.querySelector("[data-nvyu-figwrap]");
      const figEl = root.querySelector("[data-nvyu-fig]");
      const figCapEl = root.querySelector("[data-nvyu-fig-cap]");
      const inputBra = root.querySelector(`#nvyu-bra-${sid}`);
      const inputA = root.querySelector(`#nvyu-under-${sid}`);
      const inputB = root.querySelector(`#nvyu-bust-${sid}`);
      const resFast = root.querySelector("[data-nvyu-result-fast]");
      const resMeas = root.querySelector("[data-nvyu-result-measure]");
      const resQuiz = root.querySelector("[data-nvyu-result-quiz]");
      const cardsFast = root.querySelector("[data-nvyu-cards-fast]");
      const cardsMeas = root.querySelector("[data-nvyu-cards-measure]");
      const cardsQuiz = root.querySelector("[data-nvyu-cards-quiz]");
      const tableTitle = root.querySelector("[data-nvyu-table-title]");
      const tableHead = root.querySelector("[data-nvyu-tablehead]");
      const tableBody = root.querySelector("[data-nvyu-tablebody]");
      const tableHint = root.querySelector("[data-nvyu-table-hint]");
      const symptomBtns = [...root.querySelectorAll("[data-nvyu-symptom]")];
      const nudge = root.querySelector("[data-nvyu-nudge]");
      const quizBtns = [...root.querySelectorAll("[data-nvyu-q]")];
      const branchNipple = root.querySelector('[data-nvyu-branch="nipple"]');
      const stickyTitle = root.querySelector("[data-nvyu-sticky-title]");
      const stickySub = root.querySelector("[data-nvyu-sticky-sub]");
      const stickyCta = root.querySelector("[data-nvyu-sticky-cta]");

      let state = { tab:(mode==="bra")?"snel":"meten", bra:"", a:"", b:"", symptoms:{}, measuredWhen:null, quiz:{pain:null,feel:null,neck:null,nipple:null} };

      const loadState = () => { try { const raw = localStorage.getItem(LS_KEY); if (!raw) return; const parsed = JSON.parse(raw); if (parsed && typeof parsed==="object") state = Object.assign(state, parsed); } catch(e) {} };
      const saveState = () => { try { localStorage.setItem(LS_KEY, JSON.stringify(state)); } catch(e) {} };

      const lockScroll = (on) => { document.documentElement.style.overflow = on?"hidden":""; document.body.style.overflow = on?"hidden":""; };

      const openModal = () => {
        if (!modal) return;
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden","false");
        lockScroll(true);
        track("open", { page_handle: currentHandle, mode });
        setActiveTab(state.tab, true);
      };
      const closeModal = () => {
        if (!modal) return;
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden","true");
        lockScroll(false);
        if (openBtn) openBtn.focus();
      };

      if (openBtn) openBtn.addEventListener("click", (e) => { e.preventDefault(); openModal(); });
      closeEls.forEach(el => el.addEventListener("click", (e) => { e.preventDefault(); closeModal(); }));
      document.addEventListener("keydown", (e) => { if (modal && modal.classList.contains("is-open") && e.key === "Escape") closeModal(); });

      const setActiveTab = (tab, silent) => {
        state.tab = tab;
        tabs.forEach(t2 => {
          const active = t2.dataset.nvyuTab === tab;
          t2.classList.toggle("is-active", active);
          t2.setAttribute("aria-selected", active?"true":"false");
        });
        panes.forEach(p => p.classList.toggle("is-active", p.dataset.nvyuPane === tab));
        if (!silent) track("tab", { tab, mode });
        saveState();
      };
      tabs.forEach(t2 => t2.addEventListener("click", () => setActiveTab(t2.dataset.nvyuTab)));
      gotoBtns.forEach(b => b.addEventListener("click", () => setActiveTab(b.dataset.nvyuGoto)));

      // ─── VARIANT APPLY (v5 baseline) ─────────────────────────────────────────
      const findNearestProductRoot = () => root.closest("section, .shopify-section, .product, .product__info, .product-info, .product-form, [data-product-section], [data-section-type], main") || root.parentElement || document;
      const findNearestProductForm = () => { const c = findNearestProductRoot(); if (!c) return null; let f = c.querySelector('form[action*="/cart/add"]'); return f || document.querySelector('form[action*="/cart/add"]'); };
      // v8: size-alias canonicalisatie — live varianten gebruiken XXL/XXL+,
      // sommige charts/teksten 2XL/2XL+. Canoniek maken vóór vergelijking,
      // zodat de "Kies"-knop altijd de juiste variant selecteert.
      const sizeCanon = (str) => String(str||"").toUpperCase().trim().replace(/\bXXXL\b/g,"3XL").replace(/\bXXL\b/g,"2XL");
      // v7.1: tokenMatch robuuster — exact match, token-in-string, en startsWith/contains met grenzen
      const tokenMatch = (str, target) => {
        const s = sizeCanon(str);
        const tg = sizeCanon(target);
        if (!s || !tg) return false;
        if (s === tg) return true;
        // Token-based match (gesplitst op niet-alfanumeriek)
        const tokens = s.split(/[^0-9A-Z\+]+/).filter(Boolean);
        if (tokens.includes(tg)) return true;
        // Match op " / "-separators (Shopify variant titles zoals "XL / Zwart")
        if (s.split(/\s*\/\s*/).includes(tg)) return true;
        // Strip spaces en match volledig
        if (s.replace(/\s+/g,'') === tg.replace(/\s+/g,'')) return true;
        return false;
      };
      const clickLikeHuman = (el) => { if (!el) return false; try{el.scrollIntoView({block:"center",inline:"center",behavior:"smooth"});}catch(e){} try{if(el.focus)el.focus({preventScroll:true});}catch(e){} try{el.dispatchEvent(new MouseEvent("pointerdown",{bubbles:true}));}catch(e){} try{el.dispatchEvent(new MouseEvent("mousedown",{bubbles:true}));}catch(e){} try{if(el.click)el.click();}catch(e){} try{el.dispatchEvent(new MouseEvent("mouseup",{bubbles:true}));}catch(e){} try{el.dispatchEvent(new MouseEvent("pointerup",{bubbles:true}));}catch(e){} return true; };
      const hasVariantUI = () => { const scope = findNearestProductRoot() || document; return ['form[action*="/cart/add"]','.variant-picker','[data-variant-picker]','.product-form__input','input[name="id"]','input[type="radio"]','select'].some(sel => !!scope.querySelector(sel)); };
      const waitForVariantUI = async (ms=2200) => { const t0=Date.now(); while (Date.now()-t0 < ms) { if (hasVariantUI()) return true; await sleep(100); } return hasVariantUI(); };
      const getSelectedSignature = () => { const form = findNearestProductForm(); const scope = findNearestProductRoot() || document; const sig = []; const radios = form ? [...form.querySelectorAll('input[type="radio"]')] : []; const c = radios.find(r => r.checked); if (c) sig.push(`radio:${(c.value||"").toUpperCase()}`); const selects = form ? [...form.querySelectorAll("select")] : [...scope.querySelectorAll("select")]; selects.forEach(sel => { const o = sel.options && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null; if (o) sig.push(`select:${(o.value||o.textContent||"").toUpperCase()}`); }); const id = (form ? form.querySelector('input[name="id"]') : null) || scope.querySelector('input[name="id"]'); if (id && id.value) sig.push(`id:${id.value}`); return sig.join("|"); };
      const findVariantPickerAnchor = () => { const scope=findNearestProductRoot()||document; const form=findNearestProductForm(); return [form&&form.querySelector(".variant-picker"), form&&form.querySelector("[data-variant-picker]"), form&&form.querySelector(".product-form__input"), scope.querySelector(".variant-picker"), scope.querySelector("[data-variant-picker]"), scope.querySelector(".product-form__input"), form].filter(Boolean)[0] || null; };
      const pulseHighlight = (el) => { if (!el) return; const prev=el.style.boxShadow, prevTr=el.style.transition; el.style.transition="box-shadow 180ms ease"; el.style.boxShadow="0 0 0 3px rgba(0,0,0,0.18)"; setTimeout(()=>{ el.style.boxShadow="0 0 0 0 rgba(0,0,0,0)"; setTimeout(()=>{ el.style.boxShadow=prev; el.style.transition=prevTr; }, 220); }, 220); };
      const applyOnce = (size) => {
        const form = findNearestProductForm();
        const scope = findNearestProductRoot() || document;
        const target = String(size||"").trim().toUpperCase();
        if (!target) return false;
        if (form) {
          const radios = [...form.querySelectorAll('input[type="radio"]')];
          const m = radios.find(r => tokenMatch(r.value, target));
          if (m) { m.checked = true; m.dispatchEvent(new Event("input",{bubbles:true})); m.dispatchEvent(new Event("change",{bubbles:true})); return true; }
          for (const r of radios) {
            const id = r.getAttribute("id"); if (!id) continue;
            const lab = form.querySelector(`label[for="${CSS.escape(id)}"]`);
            if (lab && tokenMatch(lab.textContent, target)) { clickLikeHuman(lab); r.checked = true; r.dispatchEvent(new Event("input",{bubbles:true})); r.dispatchEvent(new Event("change",{bubbles:true})); return true; }
          }
        }
        for (const sc of uniq([form, scope, document]).filter(Boolean)) {
          const selects = [...sc.querySelectorAll("select")];
          for (const sel of selects) {
            const opt = [...sel.options].find(o => tokenMatch(o.value, target) || tokenMatch(o.textContent, target));
            if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event("input",{bubbles:true})); sel.dispatchEvent(new Event("change",{bubbles:true})); return true; }
          }
        }
        const cands = uniq([...(scope ? [...scope.querySelectorAll("button,[role='button'],label,a")] : []), ...[...document.querySelectorAll("button,[role='button'],label,a")]]);
        const attrKeys = ["data-option-value","data-value","data-variant-title","data-variant","data-option","data-name","aria-label","title","value"];
        const m = cands.find(el => {
          if (el.hasAttribute("disabled") || el.getAttribute("aria-disabled") === "true") return false;
          for (const k of attrKeys) { const v = el.getAttribute && el.getAttribute(k); if (v && tokenMatch(v, target)) return true; }
          return !!(el.textContent && tokenMatch(el.textContent.trim(), target));
        });
        if (m) { clickLikeHuman(m); const linked = m.getAttribute && m.getAttribute("for"); if (linked) { const inp = document.querySelector(`#${CSS.escape(linked)}`); if (inp) { try { inp.checked = true; inp.dispatchEvent(new Event("input",{bubbles:true})); inp.dispatchEvent(new Event("change",{bubbles:true})); } catch(e) {} } } return true; }
        return false;
      };
      const verifyApplied = (size, before) => { const after = getSelectedSignature(); if (!after) return false; if (before && after !== before) return true; return tokenMatch(after, String(size||"").trim().toUpperCase()); };
      // v7.1: debug-mode helper voor variant-apply troubleshooting
      const DEBUG_MODE = (() => { try { return /[?&]nvyu_debug=1/.test(window.location.search); } catch(e) { return false; } })();
      const dlog = (...args) => { if (DEBUG_MODE) console.log("[NVY v8]", ...args); };

      const applySizeToCurrentPage = async (size) => {
        const target = String(size||"").trim().toUpperCase();
        if (!target) return { ok:false, reason:"no_target" };
        dlog("apply: target =", target, "currentHandle =", currentHandle);
        await waitForVariantUI(2200);
        const before = getSelectedSignature();
        dlog("apply: before-signature =", before);

        // v7.1: log alle mogelijke variant-targets in DOM voor debugging
        if (DEBUG_MODE) {
          const form = findNearestProductForm();
          if (form) {
            const radios = [...form.querySelectorAll('input[type="radio"]')].map(r => r.value);
            const labels = [...form.querySelectorAll('label')].map(l => (l.textContent||"").trim().slice(0, 30));
            const opts = [...form.querySelectorAll('select option')].map(o => o.value || o.textContent);
            dlog("apply: scanned radios =", radios);
            dlog("apply: scanned labels =", labels.filter(Boolean).slice(0,12));
            dlog("apply: scanned options =", opts);
          }
        }

        const attempts = [{d:0},{d:120},{d:260},{d:520},{d:900}];
        for (let i = 0; i < attempts.length; i++) {
          if (attempts[i].d) await sleep(attempts[i].d);
          const did = applyOnce(target); if (!did) { dlog("apply attempt", i, "did=false"); continue; }
          await sleep(80);
          if (verifyApplied(target, before)) {
            dlog("apply ok at attempt", i);
            const a = findVariantPickerAnchor();
            if (a) { try { a.scrollIntoView({block:"center",behavior:"smooth"}); } catch(e) {} pulseHighlight(a); }
            return { ok:true, reason:"applied" };
          }
        }
        await sleep(250); const did2 = applyOnce(target); await sleep(80);
        if (did2 && verifyApplied(target, before)) {
          dlog("apply ok at late retry");
          const a = findVariantPickerAnchor();
          if (a) { try { a.scrollIntoView({block:"center",behavior:"smooth"}); } catch(e) {} pulseHighlight(a); }
          return { ok:true, reason:"applied_late" };
        }
        dlog("apply: NOT FOUND for target", target, "after-signature =", getSelectedSignature());
        return { ok:false, reason:"not_found" };
      };

      // ─── v6: renderMatchCards ──────────────────────────────────────────────
      const renderMatchCards = (container, matches, context) => {
        if (!container) return;
        container.innerHTML = "";
        if (!matches || !matches.length) {
          container.innerHTML = `<div class="nvyU__matchEmpty">${T("geen_geschikte_modellen_voor_deze_maat", "Geen geschikte modellen voor deze maat. Gebruik Meten of bekijk de maattabel.")}</div>`;
          updateSticky([], context);
          return;
        }

        matches.forEach((m, idx) => {
          const p = PRODUCTS[m.key]; if (!p) return;
          const isBest = idx === 0;
          const isCurrent = p.handle === currentHandle;
          const lowScore = m.score < 70;

          const card = document.createElement("div");
          card.className = "nvyU__matchCard" + (isBest ? " is-best" : "");
          card.style.animationDelay = (idx * 70) + "ms";

          // Image
          const imgWrap = document.createElement("div");
          imgWrap.className = "nvyU__matchImg is-loading";
          card.appendChild(imgWrap);
          fetchProductImage(p.handle).then(url => {
            imgWrap.classList.remove("is-loading");
            if (url) {
              const img = document.createElement("img");
              img.src = url; img.alt = p.name; img.loading = "lazy";
              imgWrap.appendChild(img);
            }
          }).catch(() => { imgWrap.classList.remove("is-loading"); });

          // Info
          const info = document.createElement("div");
          info.className = "nvyU__matchInfo";

          const row = document.createElement("div");
          row.className = "nvyU__matchRow";
          const badge = document.createElement("span");
          if (isBest) { badge.className = "nvyU__matchBadge"; badge.innerHTML = '★ ' + T("beste_match", "BESTE MATCH"); }
          else if (lowScore) { badge.className = "nvyU__matchBadge nvyU__matchBadge--warn"; badge.textContent = T("past_met_aandacht", "PAST, MET AANDACHT"); }
          else { badge.className = "nvyU__matchBadge nvyU__matchBadge--ok"; badge.textContent = T("past_ook", "PAST OOK"); }
          row.appendChild(badge);
          info.appendChild(row);

          const name = document.createElement("div");
          name.className = "nvyU__matchName";
          name.textContent = p.name;
          info.appendChild(name);

          if (m.size) {
            const sz = document.createElement("div");
            sz.className = "nvyU__matchSize";
            sz.innerHTML = `${T("jouw_maat", "Jouw maat")}: <strong>${m.size}</strong>`;
            info.appendChild(sz);
          }

          if (m.hint) {
            const hint = document.createElement("div");
            hint.className = "nvyU__matchHint";
            hint.textContent = m.hint;
            info.appendChild(hint);
          }

          card.appendChild(info);

          // CTA
          const ctaWrap = document.createElement("div");
          ctaWrap.className = "nvyU__matchCta";
          if (isCurrent && m.size) {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "nvyU__btn " + (isBest ? "nvyU__btn--accent" : "nvyU__btn--primary");
            btn.textContent = `${T("kies", "Kies")} ${m.size}`;
            btn.addEventListener("click", async () => {
              const original = btn.textContent;
              btn.disabled = true; btn.textContent = T("bezig", "Bezig…"); btn.style.opacity = ".85";
              const r = await applySizeToCurrentPage(m.size);
              track("apply_size", { from: context, product: m.key, size: m.size, ok: r.ok?1:0, reason: r.reason, mode });
              if (r.ok) { btn.textContent = T("gekozen", "Gekozen ✓"); btn.style.opacity = "1"; await sleep(220); closeModal(); setTimeout(()=>{btn.disabled=false;btn.textContent=original;btn.style.opacity="";},700); }
              else {
                btn.disabled = false;
                btn.textContent = T("kies_handmatig", "Kies handmatig");
                btn.style.opacity = "1";
                const anchor = findVariantPickerAnchor();
                if (anchor) { try { anchor.scrollIntoView({block:"center",behavior:"smooth"}); } catch(e) {} pulseHighlight(anchor); }
                setTimeout(() => { btn.textContent = original; }, 1800);
              }
            });
            ctaWrap.appendChild(btn);
          } else {
            const a = document.createElement("a");
            a.className = "nvyU__btn " + (isBest ? "nvyU__btn--primary" : "nvyU__btn--ghost");
            a.href = p.url;
            a.textContent = T("bekijk_product", "Bekijk product");
            a.addEventListener("click", () => track("click_product", { from: context, product: m.key, size: m.size||"", mode }));
            ctaWrap.appendChild(a);
          }
          card.appendChild(ctaWrap);

          container.appendChild(card);
        });

        updateSticky(matches, context);
      };

      // ─── STICKY bottom-bar ─────────────────────────────────────────────────
      const updateSticky = (matches, context) => {
        if (!stickyTitle || !stickyCta) return;
        stickyCta.innerHTML = "";
        if (!matches || !matches.length) {
          stickyTitle.textContent = T("vul_je_maat_in_voor_jouw", "Vul je maat in voor jouw beste match");
          if (stickySub) stickySub.textContent = T("fit_days_shipping", "14 dagen passen · €3,95 verzending · gratis vanaf €50");
          const close = document.createElement("button");
          close.type = "button"; close.className = "nvyU__btn nvyU__btn--ghost"; close.textContent = T("sluiten", "Sluiten");
          close.addEventListener("click", () => closeModal());
          stickyCta.appendChild(close);
          return;
        }
        const best = matches[0];
        const p = PRODUCTS[best.key]; if (!p) return;
        stickyTitle.innerHTML = `<strong>${best.size || "•"}</strong> · ${p.name}`;
        if (stickySub) stickySub.textContent = best.hint ? best.hint.substring(0, 80) : "";

        if (p.handle === currentHandle && best.size) {
          const btn = document.createElement("button");
          btn.type = "button"; btn.className = "nvyU__btn nvyU__btn--accent";
          btn.textContent = `${T("kies", "Kies")} ${best.size}`;
          btn.addEventListener("click", async () => {
            btn.disabled = true; btn.textContent = T("bezig", "Bezig…");
            const r = await applySizeToCurrentPage(best.size);
            track("apply_size", { from:"sticky", product:best.key, size:best.size, ok:r.ok?1:0, reason:r.reason, mode });
            if (r.ok) { await sleep(240); closeModal(); }
            else {
              btn.disabled = false;
              btn.textContent = T("kies_handmatig", "Kies handmatig");
              const anchor = findVariantPickerAnchor();
              if (anchor) { try { anchor.scrollIntoView({block:"center",behavior:"smooth"}); } catch(e) {} pulseHighlight(anchor); }
              setTimeout(() => { btn.textContent = `${T("kies", "Kies")} ${best.size}`; }, 1800);
            }
          });
          stickyCta.appendChild(btn);
        } else {
          const a = document.createElement("a");
          a.className = "nvyU__btn nvyU__btn--primary"; a.href = p.url; a.textContent = T("bekijk", "Bekijk");
          a.addEventListener("click", () => track("click_product", { from:"sticky", product:best.key, size:best.size||"", mode }));
          stickyCta.appendChild(a);
        }
      };

      // ─── QUIZ ──────────────────────────────────────────────────────────────
      const computeQuizRecommendation = () => {
        const q = state.quiz;
        if (!q.pain || !q.feel || !q.neck) return null;
        const showNipple = (q.feel === "natural" || q.pain === "pressure");
        if (branchNipple) branchNipple.style.display = showNipple ? "" : "none";
        if (showNipple && !q.nipple) return null;
        if (q.pain === "bounce") return "lumasport_bra";
        if (q.pain === "smooth") return "tanktop";
        if (q.pain === "shape") return (q.neck === "low") ? "pushup" : "forma";
        if (q.pain === "pressure") {
          if (q.feel === "firm") return "tanktop";
          if (q.feel === "support") return (q.neck === "low") ? "contour" : "forma";
          return (q.nipple === "prefer_not") ? ((q.neck === "low") ? "pushup" : "forma") : "contour";
        }
        if (q.feel === "firm") return "tanktop";
        if (q.feel === "support") return "forma";
        return (q.nipple === "prefer_not") ? "forma" : "contour";
      };
      const setQuizActive = (qKey, a) => quizBtns.forEach(btn => { if (btn.dataset.nvyuQ === qKey) btn.classList.toggle("is-active", btn.dataset.nvyuA === a); });
      const updateQuiz = () => {
        if (cardsQuiz) cardsQuiz.innerHTML = "";
        const rec = computeQuizRecommendation();
        if (!rec) { if (resQuiz) resQuiz.textContent = T("beantwoord_de_vragen_voor_modeladvies", "Beantwoord de vragen voor modeladvies."); return; }
        const p = PRODUCTS[rec];
        let reason = "";
        if (rec === "contour") reason = T("natuurlijk_comfort_en_open_draaggevoel", "Natuurlijk comfort en open draaggevoel.");
        if (rec === "forma") reason = T("meer_ondersteuning_en_mooier_silhouet", "Meer ondersteuning en mooier silhouet.");
        if (rec === "lumasport_bra") reason = T("meer_grip_en_stabiliteit_bij_bewegen", "Meer grip en stabiliteit bij bewegen.");
        if (rec === "tanktop") reason = T("meer_bedekking_en_smoothing", "Meer bedekking en smoothing.");
        if (rec === "pushup") reason = T("laag_uitgesneden_outfits_duidelijke_cupvorm", "Laag uitgesneden outfits + duidelijke cupvorm.");
        if (resQuiz) resQuiz.innerHTML = `<span class="nvyU__fitTag nvyU__fitTag--good">${T("aanbevolen_model", "Aanbevolen model")}</span><br><strong>${p.name}</strong><br><span style="color:var(--nvy-muted)">${reason}</span>`;
        renderMatchCards(cardsQuiz, [{ key: rec, size: null, score: 100, hint: reason }], "quiz");
        track("quiz_complete", { recommended_product: rec, mode });
      };
      quizBtns.forEach(btn => btn.addEventListener("click", () => {
        const qKey = btn.dataset.nvyuQ, a = btn.dataset.nvyuA;
        state.quiz[qKey] = a; setQuizActive(qKey, a);
        track("quiz_answer", { q: qKey, a, mode }); saveState();
        updateQuiz(); handleFast();
      }));
      symptomBtns.forEach(btn => btn.addEventListener("click", () => {
        const k = btn.dataset.nvyuSymptom;
        const on = !state.symptoms[k]; state.symptoms[k] = on;
        btn.classList.toggle("is-active", on); saveState();
        track("symptom_click", { symptom:k, active:on?1:0, mode });
        if (nudge) { const any = Object.values(state.symptoms).some(Boolean); nudge.style.display = any ? "" : "none"; }
      }));

      // ─── v8.4: "Wanneer gemeten?"-check ────────────────────────────────────
      // Veel klanten vullen vol overtuiging een maat in die jaren geleden in
      // een winkel is gemeten. Die overtuiging val je niet aan; je opent 'm
      // zacht: schuld extern (lichamen veranderen, merken meten verschillend),
      // kennis-cadeau (sister sizes) en hermeten als snelle check framen.
      const ageBtns = [...root.querySelectorAll("[data-nvyu-age]")];
      const ageCheckEl = root.querySelector("[data-nvyu-agecheck]");
      const ageTitleEl = root.querySelector("[data-nvyu-agecheck-title]");
      const ageMsgEl = root.querySelector("[data-nvyu-agecheck-msg]");
      const microCheckEl = root.querySelector("[data-nvyu-microcheck]");
      let ageParts = null;

      const renderAgeMsg = () => {
        if (!ageMsgEl) return;
        if (state.measuredWhen === "1to3") state.measuredWhen = "older";
        ageBtns.forEach(b => b.classList.toggle("is-active", b.dataset.nvyuAge === state.measuredWhen));
        ageMsgEl.innerHTML = "";
        if (!state.measuredWhen) return;
        if (state.measuredWhen === "recent") {
          ageMsgEl.innerHTML = `<div style="margin-top:8px"><span class="nvyU__fitTag nvyU__fitTag--good">✓ ${T("top_betrouwbaar_advies", "Top, betrouwbaar advies.")}</span></div>`;
          return;
        }
        const div = document.createElement("div");
        div.className = "nvyU__nudge";
        div.style.marginTop = "8px";
        const span = document.createElement("span");
        span.textContent = T("8_op_de_10_vrouwen_blijkt", "8 op de 10 vrouwen blijkt een andere maat te hebben dan ze dacht.");
        const btn = document.createElement("button");
        btn.type = "button"; btn.className = "nvyU__btn nvyU__btn--primary";
        btn.textContent = T("check_in_1_minuut", "Check in 2 minuten");
        btn.addEventListener("click", () => setActiveTab("meten"));
        div.appendChild(span); div.appendChild(btn);
        ageMsgEl.appendChild(div);
      };
      ageBtns.forEach(btn => btn.addEventListener("click", () => {
        state.measuredWhen = (state.measuredWhen === btn.dataset.nvyuAge) ? null : btn.dataset.nvyuAge;
        saveState();
        track("measured_when", { answer: state.measuredWhen || "(cleared)", mode });
        renderAgeMsg();
      }));
      const updateAgeCheck = (parts) => {
        if (!ageCheckEl) return;
        ageParts = parts || null;
        if (!parts || mode !== "bra") { ageCheckEl.style.display = "none"; return; }
        if (ageTitleEl) ageTitleEl.textContent = T("laatst_gemeten", "Laatst gemeten:");
        ageCheckEl.style.display = "";
        renderAgeMsg();
      };

      // ─── TABLE (v5 1:1; forma-chart toont nu live maatnamen XXL/XXL+) ──────
      const renderTable = () => {
        const p = PRODUCTS[currentProductKey];
        if (!p) { if (tableTitle) tableTitle.textContent = T("maattabel", "Maattabel"); if (tableHead) tableHead.innerHTML = ""; if (tableBody) tableBody.innerHTML = ""; return; }
        if (p.type === "alpha_swim") {
          if (tableTitle) tableTitle.textContent = T("maattabel_voor_zwemkleding", "Maattabel voor zwemkleding");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("maat", "Maat")}</th><th>Bust (in)</th><th>Waist (in)</th><th>Hip (in)</th><th>${p.length_label||"Length (in)"}</th></tr>`;
          if (tableBody) tableBody.innerHTML = p.ranges_swim.map(r => `<tr><td><strong>${r.s}</strong></td><td>${r.bust_in}</td><td>${r.waist_in}</td><td>${r.hip_in}</td><td>${r.length_in}</td></tr>`).join("");
          if (tableHint) tableHint.textContent = T("vul_je_taille_en_heup_in", "Vul je taille en heup (in cm) in bij Meten voor direct advies.");
          return;
        }
        if (currentProductKey === "forma") {
          if (tableTitle) tableTitle.textContent = T("forma_maatkaart_alleen_betrouwbare_combinaties", "Forma-maatkaart: alleen betrouwbare combinaties");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("gemeten_onderborst", "Gemeten onderborst")}</th><th>${T("bandgroep", "Bandgroep")}</th><th>${T("ondersteunde_cupindicaties_forma", "Ondersteunde cupindicaties → Forma")}</th></tr>`;
          if (tableBody) {
            tableBody.innerHTML = FORMA_DISPLAY_BANDS.map(band =>
              `<tr><td><strong>${formaUnderRangeLabel(band)}</strong></td><td>${band}</td><td>${compactFormaBandAdvice(band)}</td></tr>`
            ).join("");
          }
          if (tableHint) tableHint.textContent = T("cupindicatie_borstomtrek_minus_gemeten_onderborst_band", "Cupindicatie = borstomtrek minus gemeten onderborst. Band 70–105 volgt de fabrikant. Band 110 en band 115 zijn apart gekalibreerd; * betekent extender gebruiken. Ontbreekt de combinatie, dan wordt geen Forma-maat geforceerd.");
          return;
        }
        if (currentProductKey === "contour") {
          if (tableTitle) tableTitle.textContent = T("contour_maatkaart_onderborst_en_borstomvang", "Contour-maatkaart: onderborst én borstomvang");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("maat", "Maat")}</th><th>${T("onderborst", "Onderborst")}</th><th>${T("borstomtrek", "Borstomtrek")}</th></tr>`;
          if (tableBody) tableBody.innerHTML = CONTOUR_TABLE_ROWS.map(r => `<tr><td><strong>${r.s}</strong></td><td>${r.under}</td><td>${r.bust}</td></tr>`).join("");
          if (tableHint) tableHint.textContent = T("de_tool_controleert_onderborst_en_borstomvang", "De tool controleert onderborst én borstomvang en kiest de grootste noodzakelijke maat. Hoge cups zijn toegestaan door de zeer soepele cup; bij G+ is Contour vooral de zachte comfortkeuze.");
          return;
        }
        if (p.type === "alpha_bra") {
          if (tableTitle) tableTitle.textContent = T("maattabel_voor_deze_bh", "Maattabel voor deze BH");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("maat", "Maat")}</th><th>${T("bh_maten_indicatie", "BH-maten (indicatie)")}</th><th>${T("omtrek", "Omtrek")}</th></tr>`;
          const order = (p.ranges || []).map(r => r.s);
          const rows = [];
          order.forEach(size => { const r = (p.ranges||[]).find(x => x.s === size); const cups = (p.cups && p.cups[size]) ? p.cups[size] : []; rows.push(`<tr><td><strong>${size}</strong></td><td>${cups.join(" · ")}</td><td>${r?rangeLabel(r.min,r.max):""}</td></tr>`); });
          if (tableBody) tableBody.innerHTML = rows.join("");
          if (tableHint) tableHint.textContent = (currentProductKey === "contour")
            ? T("contour_volgt_de_fabrikantmaatkaart_bij_overlap", "Contour volgt de fabrikantmaatkaart. Bij overlap adviseren we altijd de grotere maat.")
            : T("forma_volgt_de_chart_exact", "Forma volgt de chart exact.");
          return;
        }
        if (p.ranges_bottom) {
          if (tableTitle) tableTitle.textContent = T("maattabel_voor_dit_model", "Maattabel voor dit model");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("maat", "Maat")}</th><th>${T("taille_cm", "Taille (cm)")}</th><th>${T("heup_cm", "Heup (cm)")}</th></tr>`;
          if (tableBody) tableBody.innerHTML = p.ranges_bottom.map(r => `<tr><td><strong>${r.s}</strong></td><td>${r.waist[0]} tot ${r.waist[1]}</td><td>${r.hip[0]} tot ${r.hip[1]}</td></tr>`).join("");
          if (tableHint) tableHint.textContent = (mode === "shapewear") ? T("shapewear_op_de_grens_groter_voor", "Shapewear: op de grens groter voor comfort, kleiner voor meer compressie.") : T("op_de_grens_kies_meestal_de", "Op de grens? Kies meestal de grotere maat.");
          return;
        }
        if (p.ranges_top) {
          if (tableTitle) tableTitle.textContent = T("maattabel_voor_dit_model", "Maattabel voor dit model");
          if (tableHead) tableHead.innerHTML = `<tr><th>${T("maat", "Maat")}</th><th>${T("borstomtrek_cm", "Borstomtrek (cm)")}</th></tr>`;
          if (tableBody) tableBody.innerHTML = p.ranges_top.map(r => `<tr><td><strong>${r.s}</strong></td><td>${r.chest[0]} tot ${r.chest[1]}</td></tr>`).join("");
          if (tableHint) tableHint.textContent = T("op_de_grens_kies_meestal_de", "Op de grens? Kies meestal de grotere maat.");
        }
      };

      // ─── BH calc — v9.4: bandgroep uit onderborst, cup uit werkelijk cm-verschil ───
      const calcBand = (under) => measuredBandFromUnder(under);
      const calcCupLetter = (under, bust) => {
        const info = cupFromMeasuredDifference(Number(bust) - Number(under));
        return info ? info.cup : "AA";
      };

      // ─── handleFast / handleMeasure ────────────────────────────────────────
      const handleFast = () => {
        if (mode !== "bra") {
          if (resFast) resFast.innerHTML = `<strong>${T("tip", "Tip:")}</strong> ${T("gebruik_meten_voor_jouw_novyre_maat", "gebruik Meten voor jouw Novyre maat.")}`;
          if (cardsFast) cardsFast.innerHTML = "";
          updateSticky([]); updateAgeCheck(null); return;
        }
        const raw = inputBra ? (inputBra.value || "") : "";
        state.bra = raw; saveState();
        const bra = normalizeBra(raw);
        if (!bra) {
          if (resFast) resFast.textContent = "";
          if (cardsFast) cardsFast.innerHTML = ""; updateSticky([]); updateAgeCheck(null); return;
        }
        const parts = parseBra(bra);
        if (!parts) {
          if (resFast) resFast.innerHTML = `<strong>${T("zo_invullen", "Zo invullen:")}</strong> ${T("85e_zonder_spaties_uk_maten_zoals", "85E (zonder spaties). UK-maten zoals 34DD werken ook.")}`;
          if (cardsFast) cardsFast.innerHTML = ""; updateSticky([]); updateAgeCheck(null);
          track("fast_input", { ok:0, mode }); return;
        }
        track("fast_input", { ok:1, bra, mode });
        const quizRec = computeQuizRecommendation();
        const matches = getMatchingProductsByBra(bra, currentProductKey, quizRec);
        if (resFast) {
          const euLabel = `${parts.band}${parts.cup}`;
          const basis = parts.uk ? `${T("op_basis_van", "Op basis van")} ${parts.uk} (UK)` : T("jouw_bh_maat", "Jouw BH-maat");
          const txt = matches.length === 1 ? T("1_passend_model", "1 passend model") : T("matches_length_passende_modellen_matches_length", "%count% passende modellen").replace("%count%", matches.length);
          resFast.innerHTML = `<div class="nvyU__resRow"><span class="nvyU__sizeBig">${euLabel}</span><div><strong>${basis}</strong><br><span class="nvyU__resSub">${txt}.</span></div></div>`;
        }
        renderMatchCards(cardsFast, matches, "fast");
        updateAgeCheck(parts);
        const primary = matches[0];
        if (primary) track("fast_complete", { recommended_product: primary.key, size: primary.size || "(n/a)", bra, mode, n_matches: matches.length });
      };

      const handleMeasure = () => {
        const aVal = Number(inputA ? inputA.value : "");
        const bVal = Number(inputB ? inputB.value : "");
        state.a = inputA ? (inputA.value || "") : "";
        state.b = inputB ? (inputB.value || "") : "";
        saveState();
        const p = PRODUCTS[currentProductKey];

        if (mode !== "bra") {
          if (!p) { if (resMeas) resMeas.textContent = T("productdefinitie_ontbreekt", "Productdefinitie ontbreekt."); return; }
          if (p.type === "alpha_top") {
            if (!aVal) { if (resMeas) resMeas.textContent = T("vul_je_borstomtrek_in", "Vul je borstomtrek in."); if (cardsMeas) cardsMeas.innerHTML = ""; updateSticky([]); return; }
            const size = matchTopSize(aVal, p.ranges_top);
            if (resMeas) resMeas.innerHTML = `<strong>${T("op_basis_van_borstomtrek", "Op basis van borstomtrek")} ${aVal} cm:</strong>`;
            renderMatchCards(cardsMeas, [{ key: currentProductKey, size, score: 90, hint: "" }], "measure");
            track("measure_complete", { mode, product: currentProductKey, size, chest: aVal });
            return;
          }
          if (!aVal || !bVal) { if (resMeas) resMeas.textContent = T("vul_taille_heup_in", "Vul taille + heup in."); if (cardsMeas) cardsMeas.innerHTML = ""; updateSticky([]); return; }
          const size = matchBottomSize(aVal, bVal, p.ranges_bottom || []);
          if (resMeas) resMeas.innerHTML = `<strong>${T("op_basis_van", "Op basis van")} ${aVal}/${bVal} cm:</strong>`;
          renderMatchCards(cardsMeas, [{ key: currentProductKey, size, score: 90, hint: "" }], "measure");
          track("measure_complete", { mode, product: currentProductKey, size, waist: aVal, hip: bVal });
          return;
        }

        if (!aVal || !bVal) { if (resMeas) resMeas.textContent = T("vul_1_onderborst_2_borstomtrek_in", "Vul ① onderborst + ② borstomtrek in voor advies."); if (cardsMeas) cardsMeas.innerHTML = ""; updateSticky([]); return; }
        if (bVal <= aVal) { if (resMeas) resMeas.innerHTML = `<strong>${T("check_je_meting", "Check je meting.")}</strong> ${T("borstomtrek_2_hoort_groter_te_zijn", "Borstomtrek ② hoort groter te zijn dan onderborst ①.")}`; if (cardsMeas) cardsMeas.innerHTML = ""; updateSticky([]); return; }

        const profile = getMeasuredBraProfile(aVal, bVal);
        if (!profile) {
          if (resMeas) resMeas.textContent = T("controleer_je_metingen", "Controleer je metingen.");
          if (cardsMeas) cardsMeas.innerHTML = "";
          updateSticky([]);
          return;
        }

        const formaAdvice = getFormaMeasuredAdvice(aVal, bVal);
        const quizRec = computeQuizRecommendation();
        const matches = getMatchingProductsByBra(profile.bra, currentProductKey, quizRec, { measured:true, formaAdvice, profile });

        if (currentProductKey === "forma") {
          if (resMeas) {
            if (formaAdvice.supported) {
              const edgeText = profile.bandEdge
                ? T("je_zit_dicht_bij_een_bandgrens", " Je zit dicht bij een bandgrens; houd rekening met je voorkeur voor een stevige of zachtere onderband.")
                : "";
              const sourceText = formaAdvice.confidence === "manufacturer_exact"
                ? T("exacte_match_uit_de_fabrikantkaart", "Exacte match uit de fabrikantkaart.")
                : formaAdvice.confidence === "calibrated_110"
                  ? T("gekalibreerde_band_110_range", "Gekalibreerde band-110-range.")
                  : T("gekalibreerde_band_115_range", "Gekalibreerde band-115-range.");
              const extenderText = formaAdvice.requiresExtender
                ? T("gebruik_de_meegeleverde_extender", " Gebruik de meegeleverde extender.")
                : "";
              resMeas.innerHTML = `<div class="nvyU__resRow"><span class="nvyU__sizeBig">${formaAdvice.size}</span><div><strong>${T("jouw_forma_maat", "Jouw Forma-maat")}</strong><br><span class="nvyU__resSub">${aVal}/${bVal} cm → ${profile.bra}. ${sourceText}${extenderText}${edgeText}</span></div></div>`;
            } else {
              const best = matches[0];
              const alternative = best ? `${PRODUCTS[best.key].name} ${best.size || ""}`.trim() : T("persoonlijk_maatadvies", "persoonlijk maatadvies");
              resMeas.innerHTML = `<div class="nvyU__resRow"><span class="nvyU__sizeBig">${profile.bra}</span><div><strong>${T("forma_is_niet_de_veiligste_match", "Forma is niet de veiligste match")}</strong><br><span class="nvyU__resSub">${formaAdvice.reason} ${T("daarom_adviseren_we_hieronder", "Daarom adviseren we hieronder")}: ${alternative}.</span></div></div>`;
            }
          }
          renderMatchCards(cardsMeas, matches, "measure");
          track("measure_complete", {
            recommended_product:matches[0]?matches[0].key:null,
            size:matches[0]?matches[0].size:null,
            forma_supported:formaAdvice.supported?1:0,
            bra_indic:profile.bra,
            under_cm:aVal,
            bust_cm:bVal,
            formula:"fit_engine_v93"
          });
          return;
        }

        if (resMeas) {
          const txt = matches.length === 1 ? T("1_passend_model", "1 passend model") : T("matches_length_passende_modellen_matches_length_2", "%count% passende modellen").replace("%count%", matches.length);
          let crossTxt = "";
          const claimed = parseBra(normalizeBra(state.bra || ""));
          if (claimed) {
            const claimedEu = `${claimed.band}${claimed.cup}`;
            const claimedShown = claimed.uk ? claimed.uk : claimedEu;
            if (claimedEu !== profile.bra) {
              crossTxt = `<div class="nvyU__resSub" style="margin-top:8px">${T("eerder_vulde_je_claimedshown_in_op", "Eerder vulde je %claimed% in: op basis van je actuele centimeters is de indicatie %bra%. Elk merk meet net anders.").replace("%claimed%", claimedShown).replace("%bra%", profile.bra)}</div>`;
            } else {
              crossTxt = `<div class="nvyU__resSub" style="margin-top:8px">✓ ${T("je_meting_bevestigt_je_maat", "Je meting bevestigt je maat.")}</div>`;
            }
            track("measure_vs_claimed", { claimed:claimedEu, measured:profile.bra, match:claimedEu===profile.bra?1:0, mode });
          }
          resMeas.innerHTML = `<div class="nvyU__resRow"><span class="nvyU__sizeBig">${profile.bra}</span><div><strong>${T("jouw_maatindicatie", "Jouw maatindicatie")}</strong><br><span class="nvyU__resSub">${txt}.</span></div></div>${crossTxt}`;
        }
        renderMatchCards(cardsMeas, matches, "measure");
        track("measure_complete", { recommended_product:matches[0]?matches[0].key:null, size:matches[0]?matches[0].size:null, bra_indic:profile.bra, mode, n_matches:matches.length, formula:"fit_engine_v93" });
      };

      // ─── UI CONFIG per mode (v8: meetgids-figuur + genummerde labels) ──────
      const FIG_CAPTIONS = {
        bra: T("meet_zonder_bh_wikkel_het_meetlint", "Meet zonder BH. Wikkel het meetlint rondom je lichaam."),
        bottom: T("wikkel_het_meetlint_horizontaal_rondom_je", "Wikkel het meetlint horizontaal rondom je lichaam."),
        top: T("wikkel_het_meetlint_rondom_over_het", "Wikkel het meetlint rondom, over het volste punt.")
      };
      const setLabelChip = (el, num, text) => { if (el) el.innerHTML = `<span class="nvyU__numChip nvyU__numChip--${num}" aria-hidden="true">${num}</span>${text}`; };
      const setMeasureFig = (kind) => {
        if (figEl) figEl.innerHTML = measureSVG(kind);
        if (figCapEl) figCapEl.textContent = FIG_CAPTIONS[kind] || "";
      };

      const configureModeUI = () => {
        if (heroTitle) heroTitle.textContent = T("vind_de_juiste_maat_en_het", "Vind de juiste maat én het juiste model");
        if (heroSub) heroSub.textContent = "";
        setLabelChip(labelA, 1, T("onderborst_cm", "Onderborst (cm)"));
        setLabelChip(labelB, 2, T("borstomtrek_cm", "Borstomtrek (cm)"));
        if (hintA) hintA.textContent = T("rondom_strak_onder_de_borst", "Rondom, strak onder de borst.");
        if (hintB) hintB.textContent = T("rondom_losjes_over_het_volste_punt", "Rondom, losjes over het volste punt.");
        if (fastTitle) fastTitle.textContent = T("weet_je_je_bh_maat_al", "Weet je je BH-maat al?");
        if (fastTip) fastTip.textContent = "";
        if (measureTitle) measureTitle.textContent = T("meet_in_1_minuut", "Meet in 2 minuten");
        if (measureSub) measureSub.textContent = T("eerst_1_onder_de_borst_dan", "Eerst ① onder de borst, dan ② over het volste punt.");
        if (inputA) inputA.placeholder = T("bijv_78", "bijv. 78");
        if (inputB) inputB.placeholder = T("bijv_96", "bijv. 96");
        setMeasureFig("bra");

        if (mode === "bra") return;
        const tabQuiz = root.querySelector('[data-nvyu-tabbtn="quiz"]');
        const tabSnel = root.querySelector('[data-nvyu-tabbtn="snel"]');
        const paneQuiz = root.querySelector('[data-nvyu-paneel="quiz"]');
        const paneSnel = root.querySelector('[data-nvyu-paneel="snel"]');
        const microCheck = root.querySelector('[data-nvyu-microcheck]');
        if (tabQuiz) tabQuiz.style.display = "none";
        if (paneQuiz) paneQuiz.style.display = "none";
        if (tabSnel) tabSnel.style.display = "none";
        if (paneSnel) paneSnel.style.display = "none";
        if (microCheck) microCheck.style.display = "none";
        if (heroActions) heroActions.style.display = "none";
        state.tab = "meten";

        if (mode === "swim") {
          if (heroTitle) heroTitle.textContent = T("vind_direct_de_juiste_pasvorm", "Vind direct de juiste pasvorm");
          if (heroSub) heroSub.textContent = T("vul_taille_en_heup_in_wij", "Vul taille en heup in, wij doen de rest.");
          setLabelChip(labelA, 1, T("taille_cm", "Taille (cm)"));
          setLabelChip(labelB, 2, T("heup_cm", "Heup (cm)"));
          if (hintA) hintA.textContent = T("smalste_punt", "Smalste punt.");
          if (hintB) hintB.textContent = T("breedste_punt_horizontaal", "Breedste punt, horizontaal.");
          if (inputA) inputA.placeholder = T("bijv_75", "bijv. 75");
          if (inputB) inputB.placeholder = T("bijv_100", "bijv. 100");
          setMeasureFig("bottom");
          return;
        }
        if (mode === "slip" || mode === "string" || mode === "short" || mode === "shapewear") {
          setLabelChip(labelA, 1, T("taille_cm", "Taille (cm)"));
          setLabelChip(labelB, 2, T("heup_cm", "Heup (cm)"));
          if (hintA) hintA.textContent = T("smalste_punt", "Smalste punt.");
          if (hintB) hintB.textContent = T("breedste_punt_horizontaal", "Breedste punt, horizontaal.");
          if (inputA) inputA.placeholder = T("bijv_75", "bijv. 75");
          if (inputB) inputB.placeholder = T("bijv_100", "bijv. 100");
          setMeasureFig("bottom");
          return;
        }
        if (mode === "sport") {
          const p = PRODUCTS[currentProductKey];
          if (p && p.type === "alpha_top") {
            setLabelChip(labelA, 1, T("borstomtrek_cm", "Borstomtrek (cm)"));
            if (hintA) hintA.textContent = T("horizontaal_om_het_volste_deel", "Horizontaal om het volste deel.");
            if (inputA) inputA.placeholder = T("bijv_100", "bijv. 100");
            if (fieldB) fieldB.style.display = "none";
            setMeasureFig("top");
          } else {
            // v8 fix: sport-bottoms (legging) toonden onterecht onderborst/borstomtrek
            setLabelChip(labelA, 1, T("taille_cm", "Taille (cm)"));
            setLabelChip(labelB, 2, T("heup_cm", "Heup (cm)"));
            if (hintA) hintA.textContent = T("smalste_punt", "Smalste punt.");
            if (hintB) hintB.textContent = T("breedste_punt_horizontaal", "Breedste punt, horizontaal.");
            if (inputA) inputA.placeholder = T("bijv_75", "bijv. 75");
            if (inputB) inputB.placeholder = T("bijv_100", "bijv. 100");
            setMeasureFig("bottom");
          }
        }
      };

      // ─── STARTUP ───────────────────────────────────────────────────────────
      loadState();
      if (inputBra && state.bra) inputBra.value = state.bra;
      if (inputA && state.a) inputA.value = state.a;
      if (inputB && state.b) inputB.value = state.b;
      symptomBtns.forEach(btn => btn.classList.toggle("is-active", !!state.symptoms[btn.dataset.nvyuSymptom]));
      if (nudge) { const any = Object.values(state.symptoms).some(Boolean); nudge.style.display = any ? "" : "none"; }
      quizBtns.forEach(btn => { if (state.quiz[btn.dataset.nvyuQ] === btn.dataset.nvyuA) btn.classList.add("is-active"); });

      configureModeUI();
      renderTable();

      if (inputBra) inputBra.addEventListener("input", handleFast);
      if (inputA) inputA.addEventListener("input", handleMeasure);
      if (inputB) inputB.addEventListener("input", handleMeasure);

      // v8: focus op een veld licht de bijbehorende meetlijn op
      if (inputA && figWrap) {
        inputA.addEventListener("focus", () => figWrap.classList.add("hot-1"));
        inputA.addEventListener("blur", () => figWrap.classList.remove("hot-1"));
      }
      if (inputB && figWrap) {
        inputB.addEventListener("focus", () => figWrap.classList.add("hot-2"));
        inputB.addEventListener("blur", () => figWrap.classList.remove("hot-2"));
      }

      if (mode === "bra") { updateQuiz(); handleFast(); }
      handleMeasure();
      setActiveTab(state.tab || (mode === "bra" ? "snel" : "meten"), true);
      updateSticky([]);

      try {
        const issues = [];
        for (const [k, p] of Object.entries(PRODUCTS)) if (!p.name || !p.url || !p.handle) issues.push([k, "missing field"]);
        if (issues.length) console.warn("NVY v8 validation:", issues);
      } catch(e) {}
    });
  };

  // ------------------------------------------------------------------------------
  //  LOAD HOOKS
  // ------------------------------------------------------------------------------
  const safeInit = () => { try { if (window.__NVYU_INIT_ALL__) window.__NVYU_INIT_ALL__(); } catch(e) { console.warn("NVY init", e); } };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", safeInit);
  else safeInit();
  document.addEventListener("shopify:section:load", safeInit);
  document.addEventListener("shopify:section:select", safeInit);
  setTimeout(safeInit, 350);
  setTimeout(safeInit, 1100);
})();

/* NOVYRE SIZE TOOL v19.0 — UX-LAAG IN DEZE VOLLEDIGE VERSIE
   Gebruik:
   1. Zet je originele Novyre maathulp terug.
   2. Verwijder alle losse patches v11 t/m v18.
   3. Plak deze code één keer onder de originele maathulp.

   Belangrijk:
   - Deze laag doet UX, copy, layout en frictie richting meten.
   - Forma FIT-SAFE-logica en Contour-fallback zitten geïntegreerd in de hoofdtool hierboven.
*/

(() => {
  if (window.__NOVYRE_SIZE_TOOL_V19_UX_ONLY__) return;
  window.__NOVYRE_SIZE_TOOL_V19_UX_ONLY__ = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const T = window.__nvyMaatT || (window.__nvyMaatT = (function(){
    var d = {};
    try { var e = document.getElementById('nvy-maat-i18n'); if (e) d = JSON.parse(e.textContent) || {}; } catch (_) {}
    return function(k, nl){
      var v = d[k];
      if (v === undefined || v === null || v === '' || /^Translation missing/.test(String(v))) return nl;
      return v;
    };
  })());

  const esc = (v) => String(v ?? "").replace(/[&<>'"]/g, c => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;"
  }[c]));

  const getRoot = () => $("[data-nvyu-root]");

  const getHandle = () => {
    try {
      const root = getRoot();

      return String(
        window.meta?.product?.handle ||
        $("[data-product-handle]")?.getAttribute("data-product-handle") ||
        root?.getAttribute("data-current-handle") ||
        (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] ||
        ""
      ).toLowerCase();
    } catch(e) {
      return "";
    }
  };

  const getMode = () => {
    const root = getRoot();
    return String(root?.getAttribute("data-nvy-mode") || "").toLowerCase();
  };

  const context = () => {
    const h = getHandle();
    const mode = getMode();

    if (
      h.includes("badpak") ||
      h.includes("bikini") ||
      h.includes("badmode") ||
      h.includes("badkleding") ||
      h.includes("zwem") ||
      mode === "swim"
    ) {
      return "badmode";
    }

    if (
      h.includes("string") ||
      h.includes("slip") ||
      h.includes("short") ||
      h.includes("brief") ||
      h.includes("hipster") ||
      h.includes("thong") ||
      mode === "string" ||
      mode === "slip" ||
      mode === "short" ||
      mode === "bottom"
    ) {
      return "ondermode";
    }

    if (
      h.includes("bodysuit") ||
      h.includes("jumpsuit") ||
      h.includes("corvia") ||
      h.includes("umbra") ||
      h.includes("lunga") ||
      h.includes("motion") ||
      mode === "shapewear"
    ) {
      return "shapewear";
    }

    if (
      h.includes("legging") ||
      h.includes("sport-set") ||
      mode === "sport"
    ) {
      return "sport";
    }

    return "bh";
  };

  const isForma = () => getHandle().includes("luma-forma-bh");

  const copy = () => {
    const c = context();

    if (isForma()) {
      return {
        titleSmall: T("meet_je_forma_maat", "Meet je Forma-maat"),
        heroTitle: T("voor_forma_telt_het_meetlint", "Voor Forma telt het meetlint"),
        heroSub: T("draag_je_ergens_85g_90d_of", "Draag je ergens 85G, 90D of iets anders? Helemaal prima. De Luma Forma BH heeft een eigen pasvorm, daarom meten we 2 minuten opnieuw voordat je bestelt."),
        primaryCta: T("meet_mijn_forma_maat_in_2", "Meet mijn Forma-maat in 2 minuten"),
        oldCta: T("geen_meetlint_bij_de_hand_oude", "Geen meetlint bij de hand? Oude maat vergelijken"),
        benefitTitle: T("2_minuten_meten_voorkomt_het_meeste", "2 minuten meten voorkomt het meeste maatgedoe."),
        benefitText: T("je_zoekt_gewoon_een_bh_die", "Je zoekt gewoon een BH die direct prettig zit. Daarom vragen we je vriendelijk om eerst echt even te meten, zonder te gokken op een oude cupmaat."),
        benefitSmall: T("geen_druk_wel_duidelijk_je_oude", "Geen druk, wel duidelijk. Je oude maat mag kloppen bij een andere winkel, bij Forma rekenen we opnieuw."),
        measureTitle: T("meet_in_2_minuten_je_forma", "Meet in 2 minuten je Forma-maat"),
        measureSub: T("meet_rustig_bij_1_cm_verschil", "Meet rustig. Bij 1 cm verschil kan het advies soms veranderen."),
        oldTitle: T("indicatie_op_basis_van_je_oude", "Indicatie op basis van je oude maat"),
        oldTip: T("geen_meetlint_bij_de_hand_dan", "Geen meetlint bij de hand? Dan geven we een bruikbare richting. Meten blijft nauwkeuriger."),
        oldBoxText: T("als_je_nu_geen_meetlint_hebt", "Als je nu geen meetlint hebt, helpen we je alsnog. Dit advies is alleen minder zeker dan meten."),
        step2: T("onderborst_en_borstomtrek", "Onderborst en borstomtrek.")
      };
    }

    if (c === "badmode") {
      return {
        titleSmall: T("meet_je_novyre_maat", "Meet je Novyre-maat"),
        heroTitle: T("bij_novyre_telt_het_meetlint", "Bij Novyre telt het meetlint"),
        heroSub: T("draag_je_normaal_s_m_l", "Draag je normaal S, M, L of XL? Helemaal prima. Bij badmode wil je dat borst, taille en heup goed samenkomen, daarom meten we even opnieuw voordat je bestelt."),
        primaryCta: T("meet_mijn_maat_in_2_minuten", "Meet mijn maat in 2 minuten"),
        oldCta: T("geen_meetlint_bij_de_hand_oude", "Geen meetlint bij de hand? Oude maat vergelijken"),
        benefitTitle: T("2_minuten_meten_voorkomt_het_meeste", "2 minuten meten voorkomt het meeste maatgedoe."),
        benefitText: T("je_zoekt_badmode_die_prettig_zit", "Je zoekt badmode die prettig zit, mooi aansluit en niet knelt. Daarom vragen we je vriendelijk om eerst echt even te meten, zonder te gokken op je oude maat."),
        benefitSmall: T("geen_druk_wel_duidelijk_je_oude_2", "Geen druk, wel duidelijk. Je oude maat mag kloppen bij een andere winkel, bij Novyre rekenen we opnieuw."),
        measureTitle: T("meet_in_2_minuten_je_novyre", "Meet in 2 minuten je Novyre-maat"),
        measureSub: T("meet_rustig_bij_1_cm_verschil", "Meet rustig. Bij 1 cm verschil kan het advies soms veranderen."),
        oldTitle: T("indicatie_op_basis_van_je_oude", "Indicatie op basis van je oude maat"),
        oldTip: T("geen_meetlint_bij_de_hand_dan", "Geen meetlint bij de hand? Dan geven we een bruikbare richting. Meten blijft nauwkeuriger."),
        oldBoxText: T("als_je_nu_geen_meetlint_hebt_2", "Als je nu geen meetlint hebt, helpen we je alsnog. Dit badmode-advies is alleen minder zeker dan meten."),
        step2: T("borst_taille_en_heup", "Borst, taille en heup.")
      };
    }

    if (c === "ondermode") {
      return {
        titleSmall: T("meet_je_novyre_maat", "Meet je Novyre-maat"),
        heroTitle: T("bij_novyre_telt_het_meetlint", "Bij Novyre telt het meetlint"),
        heroSub: T("draag_je_normaal_s_m_l_2", "Draag je normaal S, M, L of XL? Helemaal prima. Voor ondermode kijken we liever naar je actuele taille en heup, zodat je maat prettig aansluit."),
        primaryCta: T("meet_mijn_maat_in_2_minuten", "Meet mijn maat in 2 minuten"),
        oldCta: T("geen_meetlint_bij_de_hand_oude", "Geen meetlint bij de hand? Oude maat vergelijken"),
        benefitTitle: T("2_minuten_meten_voorkomt_het_meeste", "2 minuten meten voorkomt het meeste maatgedoe."),
        benefitText: T("je_zoekt_ondermode_die_zacht_zit", "Je zoekt ondermode die zacht zit, mooi aansluit en niet knelt. Daarom vragen we je vriendelijk om eerst even te meten, zonder te gokken op je oude maat."),
        benefitSmall: T("geen_druk_wel_duidelijk_je_oude_2", "Geen druk, wel duidelijk. Je oude maat mag kloppen bij een andere winkel, bij Novyre rekenen we opnieuw."),
        measureTitle: T("meet_in_2_minuten_je_novyre", "Meet in 2 minuten je Novyre-maat"),
        measureSub: T("meet_rustig_bij_1_cm_verschil", "Meet rustig. Bij 1 cm verschil kan het advies soms veranderen."),
        oldTitle: T("indicatie_op_basis_van_je_oude", "Indicatie op basis van je oude maat"),
        oldTip: T("geen_meetlint_bij_de_hand_dan", "Geen meetlint bij de hand? Dan geven we een bruikbare richting. Meten blijft nauwkeuriger."),
        oldBoxText: T("als_je_nu_geen_meetlint_hebt_3", "Als je nu geen meetlint hebt, helpen we je alsnog. Dit ondermode-advies is alleen minder zeker dan meten."),
        step2: T("taille_en_heup", "Taille en heup.")
      };
    }

    if (c === "shapewear") {
      return {
        titleSmall: T("meet_je_novyre_maat", "Meet je Novyre-maat"),
        heroTitle: T("bij_novyre_telt_het_meetlint", "Bij Novyre telt het meetlint"),
        heroSub: T("draag_je_normaal_s_m_l_3", "Draag je normaal S, M, L of XL? Helemaal prima. Bij shapewear wil je steun zonder knellen, daarom meten we taille en heup opnieuw voordat je bestelt."),
        primaryCta: T("meet_mijn_maat_in_2_minuten", "Meet mijn maat in 2 minuten"),
        oldCta: T("geen_meetlint_bij_de_hand_oude", "Geen meetlint bij de hand? Oude maat vergelijken"),
        benefitTitle: T("2_minuten_meten_voorkomt_het_meeste", "2 minuten meten voorkomt het meeste maatgedoe."),
        benefitText: T("je_zoekt_shapewear_die_ondersteunt_zonder", "Je zoekt shapewear die ondersteunt zonder strak of onprettig te voelen. Daarom vragen we je vriendelijk om eerst even te meten."),
        benefitSmall: T("geen_druk_wel_duidelijk_je_oude_2", "Geen druk, wel duidelijk. Je oude maat mag kloppen bij een andere winkel, bij Novyre rekenen we opnieuw."),
        measureTitle: T("meet_in_2_minuten_je_novyre", "Meet in 2 minuten je Novyre-maat"),
        measureSub: T("meet_rustig_bij_1_cm_verschil", "Meet rustig. Bij 1 cm verschil kan het advies soms veranderen."),
        oldTitle: T("indicatie_op_basis_van_je_oude", "Indicatie op basis van je oude maat"),
        oldTip: T("geen_meetlint_bij_de_hand_dan", "Geen meetlint bij de hand? Dan geven we een bruikbare richting. Meten blijft nauwkeuriger."),
        oldBoxText: T("als_je_nu_geen_meetlint_hebt_4", "Als je nu geen meetlint hebt, helpen we je alsnog. Dit shapewear-advies is alleen minder zeker dan meten."),
        step2: T("taille_en_heup", "Taille en heup.")
      };
    }

    return {
      titleSmall: T("meet_je_novyre_maat", "Meet je Novyre-maat"),
      heroTitle: T("bij_novyre_telt_het_meetlint", "Bij Novyre telt het meetlint"),
      heroSub: T("draag_je_ergens_85g_90d_of_2", "Draag je ergens 85G, 90D of iets anders? Helemaal prima. Bij Novyre vallen modellen anders, daarom meten we 2 minuten opnieuw voordat je bestelt."),
      primaryCta: T("meet_mijn_maat_in_2_minuten", "Meet mijn maat in 2 minuten"),
      oldCta: T("geen_meetlint_bij_de_hand_oude", "Geen meetlint bij de hand? Oude maat vergelijken"),
      benefitTitle: T("2_minuten_meten_voorkomt_het_meeste", "2 minuten meten voorkomt het meeste maatgedoe."),
      benefitText: T("je_zoekt_gewoon_een_bh_die", "Je zoekt gewoon een BH die direct prettig zit. Daarom vragen we je vriendelijk om eerst echt even te meten, zonder te gokken op een oude cupmaat."),
      benefitSmall: T("geen_druk_wel_duidelijk_je_oude_2", "Geen druk, wel duidelijk. Je oude maat mag kloppen bij een andere winkel, bij Novyre rekenen we opnieuw."),
      measureTitle: T("meet_in_2_minuten_je_novyre", "Meet in 2 minuten je Novyre-maat"),
      measureSub: T("meet_rustig_bij_1_cm_verschil", "Meet rustig. Bij 1 cm verschil kan het advies soms veranderen."),
      oldTitle: T("indicatie_op_basis_van_je_oude", "Indicatie op basis van je oude maat"),
      oldTip: T("geen_meetlint_bij_de_hand_dan", "Geen meetlint bij de hand? Dan geven we een bruikbare richting. Meten blijft nauwkeuriger."),
      oldBoxText: T("als_je_nu_geen_meetlint_hebt", "Als je nu geen meetlint hebt, helpen we je alsnog. Dit advies is alleen minder zeker dan meten."),
      step2: T("onderborst_en_borstomtrek", "Onderborst en borstomtrek.")
    };
  };

  const injectCss = () => {
    if ($("#novyre-v19-ux-only-css")) return;

    const style = document.createElement("style");
    style.id = "novyre-v19-ux-only-css";

    style.textContent = `
      [data-nvyu-root].nvy19-ux .nvyU__heroProof,
      [data-nvyu-root].nvy19-ux .nvyU__heroNudge{
        display:none!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__hero{
        display:grid!important;
        grid-template-columns:minmax(0,1.1fr) minmax(330px,.9fr)!important;
        grid-template-areas:"text side" "actions side" "proof proof"!important;
        gap:18px 22px!important;
        align-items:stretch!important;
        padding:26px 28px 24px!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__heroText{
        grid-area:text!important;
        max-width:none!important;
        text-align:left!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__heroActions{
        grid-area:actions!important;
        display:flex!important;
        flex-direction:column!important;
        gap:8px!important;
        margin-top:0!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__title{
        font-size:32px!important;
        line-height:1.04!important;
        letter-spacing:-.04em!important;
        text-align:left!important;
        margin-bottom:10px!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__sub{
        font-size:15px!important;
        line-height:1.55!important;
        color:#342e29!important;
        text-align:left!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__heroActions .nvyU__bigBtn--primary{
        min-height:68px!important;
        border-radius:22px!important;
        font-size:17px!important;
        font-weight:950!important;
        box-shadow:0 20px 38px rgba(17,17,17,.22)!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__heroActions .nvyU__bigBtn--ghost{
        background:transparent!important;
        border:none!important;
        box-shadow:none!important;
        color:#746a61!important;
        min-height:auto!important;
        padding:0!important;
        width:max-content!important;
        align-self:flex-start!important;
        text-decoration:underline!important;
        text-underline-offset:4px!important;
        font-size:12px!important;
        opacity:.76!important;
      }

      [data-nvyu-root].nvy19-ux .nvyU__heroActions .nvyU__bigBtn--ghost:hover{
        opacity:1!important;
        color:#111!important;
        background:transparent!important;
        transform:none!important;
      }

      .nvy19-side{
        grid-area:side;
        display:flex;
        flex-direction:column;
        gap:12px;
      }

      .nvy19-benefit{
        flex:1;
        border:1px solid #bfe0c4;
        background:linear-gradient(180deg,#f7fdf4 0%,#edf8ef 100%);
        border-radius:22px;
        padding:18px;
        color:#173b21;
        display:flex;
        flex-direction:column;
        justify-content:center;
        box-shadow:0 12px 28px rgba(39,80,10,.08);
      }

      .nvy19-benefit strong{
        display:block;
        font-size:21px;
        line-height:1.13;
        font-weight:950;
        letter-spacing:-.02em;
        margin-bottom:8px;
      }

      .nvy19-benefit span{
        display:block;
        font-size:14px;
        line-height:1.52;
        font-weight:700;
        color:#28542f;
      }

      .nvy19-benefit small{
        display:block;
        margin-top:10px;
        font-size:12px;
        line-height:1.45;
        font-weight:750;
        color:#2e5d35;
      }

      .nvy19-steps{
        display:grid;
        grid-template-columns:repeat(3,1fr);
        gap:8px;
      }

      .nvy19-step{
        background:#fff;
        border:1px solid #e7ded5;
        border-radius:16px;
        padding:11px 10px;
        min-height:82px;
        display:flex;
        flex-direction:column;
        justify-content:center;
        gap:4px;
      }

      .nvy19-step b{
        font-size:12.5px;
        line-height:1.2;
        color:#1f1b17;
        font-weight:950;
      }

      .nvy19-step span{
        font-size:11.5px;
        line-height:1.32;
        color:#675d55;
        font-weight:650;
      }

      .nvy19-proof{
        grid-area:proof;
        display:grid;
        grid-template-columns:repeat(4,minmax(0,1fr));
        gap:10px;
      }

      .nvy19-proof div{
        display:flex;
        align-items:center;
        justify-content:center;
        gap:8px;
        min-height:58px;
        padding:11px 10px;
        border:1px solid #e9dfd5;
        background:#fff;
        border-radius:16px;
        font-size:12px;
        line-height:1.25;
        color:#4d453e;
        font-weight:850;
        text-align:center;
      }

      .nvy19-proof div::before{
        content:"✓";
        width:21px;
        height:21px;
        border-radius:999px;
        background:#27500A;
        color:#fff;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        font-size:11px;
        font-weight:950;
        flex:0 0 auto;
      }

      .nvy19-oldnote{
        margin:12px 0;
        padding:13px 14px;
        border:1px solid #efd9ba;
        background:#fff8f1;
        color:#68400d;
        border-radius:16px;
        font-size:12.7px;
        line-height:1.48;
        font-weight:650;
      }

      .nvy19-oldnote strong{
        display:block;
        color:#171511;
        font-size:14px;
        line-height:1.25;
        font-weight:950;
        margin-bottom:4px;
      }

      .nvy19-label{
        display:inline-flex;
        align-items:center;
        min-height:25px;
        padding:0 9px;
        border-radius:999px;
        background:#fff8f1;
        border:1px solid #efd9ba;
        color:#754406;
        font-size:10.8px;
        font-weight:950;
        text-transform:uppercase;
        letter-spacing:.03em;
        margin-bottom:7px;
      }

      .nvy19-actions{
        display:flex;
        gap:8px;
        flex-wrap:wrap;
        margin-top:10px;
      }

      .nvy19-btn{
        appearance:none!important;
        border:none;
        border-radius:13px;
        min-height:38px;
        padding:0 12px;
        background:#111;
        color:#fff;
        font:inherit;
        font-size:12px;
        font-weight:900;
        cursor:pointer;
        text-transform:none!important;
      }

      .nvy19-btn.ghost{
        background:#fff;
        color:#111;
        border:1px solid #ddd3c9;
      }

      @media(max-width:900px){
        [data-nvyu-root].nvy19-ux .nvyU__hero{
          grid-template-columns:1fr!important;
          grid-template-areas:"text" "side" "actions" "proof"!important;
          padding:20px 16px!important;
        }

        [data-nvyu-root].nvy19-ux .nvyU__title{
          text-align:center!important;
          font-size:25px!important;
        }

        [data-nvyu-root].nvy19-ux .nvyU__sub{
          text-align:center!important;
        }

        [data-nvyu-root].nvy19-ux .nvyU__heroActions .nvyU__bigBtn--ghost{
          align-self:center!important;
          text-align:center!important;
        }

        .nvy19-proof{
          grid-template-columns:1fr!important;
        }

        .nvy19-steps{
          grid-template-columns:1fr!important;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const setText = (selector, value, root) => {
    const el = $(selector, root);
    if (el && value) el.textContent = value;
  };

  const updateHero = (root) => {
    const c = copy();

    root.classList.add("nvy19-ux");
    root.setAttribute("data-nvy19-context", context());

    setText(".nvyU__trigger-title", c.titleSmall, root);
    setText(".nvyU__trigger-sub", T("pak_je_meetlint_2_minuten_meten", "Pak je meetlint. 2 minuten meten, veel minder kans op ruilen."), root);
    setText(".nvyU__trigger-badge", "2 min", root);

    setText("[data-nvyu-hero-title]", c.heroTitle, root);
    setText("[data-nvyu-hero-sub]", c.heroSub, root);
    setText(".nvyU__heroText .nvyU__title", c.heroTitle, root);
    setText(".nvyU__heroText .nvyU__sub", c.heroSub, root);

    const heroActions = $(".nvyU__heroActions", root);
    if (heroActions) {
      const buttons = $$("button,a", heroActions);
      if (buttons[0]) buttons[0].textContent = `${c.primaryCta} →`;
      if (buttons[1]) buttons[1].textContent = c.oldCta;
    }

    const hero = $(".nvyU__hero", root);
    if (hero) {
      let side = $(".nvy19-side", hero);

      if (!side) {
        side = document.createElement("div");
        side.className = "nvy19-side";
        hero.appendChild(side);
      }

      side.innerHTML = `
        <div class="nvy19-benefit">
          <strong>${esc(c.benefitTitle)}</strong>
          <span>${esc(c.benefitText)}</span>
          <small>${esc(c.benefitSmall)}</small>
        </div>
        <div class="nvy19-steps">
          <div class="nvy19-step">
            <b>${esc(T("1_pak_meetlint", "1. Pak meetlint"))}</b>
            <span>${esc(T("niet_schatten_echt_meten", "Niet schatten, echt meten."))}</span>
          </div>
          <div class="nvy19-step">
            <b>${esc(T("2_meet_2_punten", "2. Meet 2 punten"))}</b>
            <span>${esc(c.step2)}</span>
          </div>
          <div class="nvy19-step">
            <b>${esc(T("3_kies_advies", "3. Kies advies"))}</b>
            <span>${esc(T("minder_twijfel_bij_bestellen", "Minder twijfel bij bestellen."))}</span>
          </div>
        </div>
      `;

      let proof = $(".nvy19-proof", hero);

      if (!proof) {
        proof = document.createElement("div");
        proof.className = "nvy19-proof";
        hero.appendChild(proof);
      }

      proof.innerHTML = `
        <div>${esc(T("2_simpele_metingen", "2 simpele metingen"))}</div>
        <div>${esc(T("gratis_verzending_vanaf_50", "Gratis verzending vanaf €50"))}</div>
        <div>${esc(T("onder_50_verzending_3_95", "Onder €50, verzending €3,95"))}</div>
        <div>${esc(T("14_dagen_thuis_passen", "14 dagen thuis passen"))}</div>
      `;
    }
  };

  const updateTabsAndTitles = (root) => {
    const c = copy();

    const tabOld =
      $('[data-nvyu-tabbtn="snel"]', root) ||
      $('[data-nvyu-tab="snel"]', root);

    const tabMeasure =
      $('[data-nvyu-tabbtn="meten"]', root) ||
      $('[data-nvyu-tab="meten"]', root);

    const tabCard =
      $('[data-nvyu-tabbtn="kaart"]', root) ||
      $('[data-nvyu-tab="kaart"]', root);

    const tabHelp =
      $('[data-nvyu-tabbtn="hulp"]', root) ||
      $('[data-nvyu-tab="hulp"]', root);

    if (tabOld) tabOld.textContent = T("oude_maat_vergelijken", "Oude maat vergelijken");
    if (tabMeasure) tabMeasure.textContent = T("meetadvies", "Meetadvies");
    if (tabCard) tabCard.textContent = T("maatkaart", "Maatkaart");
    if (tabHelp) tabHelp.textContent = T("keuzehulp_2", "Keuzehulp");

    setText("[data-nvyu-measure-title]", c.measureTitle, root);
    setText("[data-nvyu-measure-sub]", c.measureSub, root);

    setText("[data-nvyu-fast-title]", c.oldTitle, root);
    setText("[data-nvyu-fast-tip]", c.oldTip, root);
  };

  const updateOldRouteNote = (root) => {
    const c = copy();

    const pane =
      $('[data-nvyu-paneel="snel"]', root) ||
      $('[data-nvyu-pane="snel"]', root) ||
      $('[data-nvyu-section="snel"]', root);

    if (!pane) return;

    let note = $(".nvy19-oldnote", pane);

    if (!note) {
      note = document.createElement("div");
      note.className = "nvy19-oldnote";

      const field =
        $("[data-nvyu-fast-input]", pane)?.closest(".nvyU__field") ||
        $("[data-nvyu-old]", pane)?.closest(".nvyU__field") ||
        $("input", pane)?.closest(".nvyU__field");

      if (field && field.parentNode) {
        field.parentNode.insertBefore(note, field);
      } else {
        pane.prepend(note);
      }
    }

    note.innerHTML = `
      <span class="nvy19-label">${esc(T("snelle_indicatie", "Snelle indicatie"))}</span>
      <strong>${esc(T("je_oude_maat_mag_gewoon_als", "Je oude maat mag gewoon als startpunt."))}</strong>
      ${esc(c.oldBoxText)}
      <div class="nvy19-actions">
        <button type="button" class="nvy19-btn" data-nvy19-go-measure>
          ${esc(T("ik_pak_toch_even_mijn_meetlint", "Ik pak toch even mijn meetlint"))}
        </button>
        <button type="button" class="nvy19-btn ghost" data-nvy19-focus-old>
          ${esc(T("ga_door_met_oude_maat", "Ga door met oude maat"))}
        </button>
      </div>
    `;
  };

  const replaceVisibleText = (root) => {
    if (!root) return;

    const c = context();

    const replacements = [
      ["Altijd gratis verzending NL & BE", "Gratis verzending vanaf €50"],
      ["altijd gratis verzending NL & BE", "gratis verzending vanaf €50"],
      ["14 dagen passen · altijd gratis verzending NL & BE", "14 dagen passen, gratis verzending vanaf €50"],
      ["14 dagen thuis passen · altijd gratis verzending NL & BE", "14 dagen passen, gratis verzending vanaf €50"],

      ["Klaar in 1 minuut", "2 simpele metingen"],
      ["klaar in 1 minuut", "2 simpele metingen"],
      ["Check in 1 minuut", "Meet in 2 minuten"],
      ["check in 1 minuut", "meet in 2 minuten"],
      ["Meet mijn maat in 1 minuut", "Meet mijn maat in 2 minuten"],
      ["Meet mijn Novyre-maat in 1 minuut", "Meet mijn Novyre-maat in 2 minuten"],

      ["swimwear", "badmode"],
      ["Swimwear", "Badmode"],

      [
        "Je zoekt gewoon een BH die direct prettig zit.",
        c === "badmode"
          ? "Je zoekt badmode die prettig zit."
          : c === "ondermode"
            ? "Je zoekt ondermode die prettig zit."
            : c === "shapewear"
              ? "Je zoekt shapewear die prettig zit."
              : "Je zoekt gewoon een BH die direct prettig zit."
      ],

      [
        "Zo zit je nieuwe BH in één keer écht lekker.",
        c === "badmode"
          ? "Zo zit je nieuwe badmode veel vaker in één keer goed."
          : c === "ondermode"
            ? "Zo zit je nieuwe ondermode veel vaker in één keer goed."
            : c === "shapewear"
              ? "Zo zit je nieuwe shapewear veel vaker in één keer goed."
              : "Zo zit je nieuwe BH in één keer écht lekker."
      ],

      [
        "oude cupmaat",
        c === "bh" ? "oude cupmaat" : "oude maat"
      ],
      [
        "oude BH-maat",
        c === "bh" ? "oude BH-maat" : "oude maat"
      ],
      [
        "BH-maat",
        c === "bh" ? "BH-maat" : "maat"
      ],

      [" · ", ", "],
      [" — ", ", "],
      [" – ", ", "]
    ];

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const p = node.parentElement;
        if (!p || ["SCRIPT", "STYLE", "NOSCRIPT"].includes(p.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        if (!p.closest("[data-nvyu-root]")) {
          return NodeFilter.FILTER_REJECT;
        }

        if (p.matches("input, textarea, option")) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(node => {
      let s = node.nodeValue;

      replacements.forEach(([from, to]) => {
        if (from && s.includes(from)) {
          s = s.split(from).join(to);
        }
      });

      node.nodeValue = s;
    });
  };

  const scrollInsidePanel = (root, target) => {
    if (!root || !target) return;

    const panel = $(".nvyU__panel", root) || target.closest(".nvyU__panel");

    try {
      if (panel && panel.contains(target)) {
        const panelRect = panel.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const y = panel.scrollTop + (targetRect.top - panelRect.top) - 70;
        panel.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
      } else {
        target.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    } catch(e) {}
  };

  const pulseTarget = (el) => {
    if (!el) return;
    try {
      const prev = el.style.boxShadow;
      const prevTr = el.style.transition;
      el.style.transition = "box-shadow .22s ease";
      el.style.boxShadow = "0 0 0 4px rgba(39,80,10,.16)";
      setTimeout(() => {
        el.style.boxShadow = "0 0 0 0 rgba(39,80,10,0)";
        setTimeout(() => {
          el.style.boxShadow = prev;
          el.style.transition = prevTr;
        }, 260);
      }, 320);
    } catch(e) {}
  };

  const openTab = (tabName) => {
    const root = getRoot();
    if (!root) return;

    const name = String(tabName || "").trim();
    if (!name) return;

    // Klik alleen de echte tab-knop. Niet opnieuw op de hero/goto-knop klikken,
    // anders blijft de klant bovenaan de modal staan.
    const tabBtn =
      $(`[data-nvyu-tabbtn="${name}"]`, root) ||
      $(`[data-nvyu-tab="${name}"]`, root);

    if (tabBtn) {
      try { tabBtn.click(); } catch(e) {}
    }

    const pane =
      $(`[data-nvyu-paneel="${name}"]`, root) ||
      $(`[data-nvyu-pane="${name}"]`, root);

    const target = name === "meten"
      ? ($("[data-nvyu-a]", root)?.closest(".nvyU__card") || pane)
      : name === "snel"
        ? ($("[data-nvyu-fast-input]", root)?.closest(".nvyU__card") || pane)
        : (pane || tabBtn);

    setTimeout(() => {
      scrollInsidePanel(root, target);
      pulseTarget(target);

      const input = name === "meten"
        ? ($("[data-nvyu-a]", root) || $("[data-nvyu-measure-a]", root) || $("input[type='number']", root))
        : name === "snel"
          ? ($("[data-nvyu-fast-input]", root) || $("[data-nvyu-old]", root) || $("input[type='text']", root))
          : null;

      if (input) {
        setTimeout(() => {
          try { input.focus({ preventScroll: true }); } catch(e) {}
        }, 260);
      }
    }, 80);
  };

  // UX-fix: hero-CTA's zoals "Meet mijn maat" en "Geen meetlint bij de hand"
  // veranderen de tab én scrollen nu direct naar het zichtbare invoerblok.
  document.addEventListener("click", (e) => {
    const goto = e.target.closest("[data-nvyu-goto]");
    const root = getRoot();

    if (!goto || !root || !root.contains(goto)) return;

    const tab = goto.getAttribute("data-nvyu-goto");
    if (!["meten", "snel", "kaart", "quiz"].includes(tab)) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    openTab(tab);
  }, true);

  document.addEventListener("click", (e) => {
    const measureBtn = e.target.closest("[data-nvy19-go-measure]");
    const oldBtn = e.target.closest("[data-nvy19-focus-old]");

    if (measureBtn) {
      e.preventDefault();
      e.stopPropagation();
      openTab("meten");
      return;
    }

    if (oldBtn) {
      e.preventDefault();
      e.stopPropagation();

      const root = getRoot();

      const input =
        $("[data-nvyu-fast-input]", root || document) ||
        $("[data-nvyu-old]", root || document) ||
        $("input[type='text']", root || document);

      if (input) {
        try {
          input.focus({ preventScroll: false });
          input.scrollIntoView({ block: "center", behavior: "smooth" });
        } catch(e) {}
      }
    }
  }, true);

  const apply = () => {
    const root = getRoot();
    if (!root) return;

    injectCss();
    updateHero(root);
    updateTabsAndTitles(root);
    updateOldRouteNote(root);
    replaceVisibleText(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }

  document.addEventListener("shopify:section:load", () => setTimeout(apply, 160));
  document.addEventListener("shopify:section:select", () => setTimeout(apply, 160));

  new MutationObserver(() => {
    clearTimeout(window.__nvy19UxTimer);
    window.__nvy19UxTimer = setTimeout(apply, 180);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: false
  });

  setTimeout(apply, 400);
  setTimeout(apply, 1200);
  setTimeout(apply, 2400);
})();